export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A datetime string with format `Y-m-d H:i:s`, e.g. `2018-05-23 13:43:32`. */
  DateTime: string;
  /** A date string with format `Y-m-d`, e.g. `2011-05-23`. */
  Date: string;
  /** A yearmonth string with format `Y-m`, e.g. `2020-11. */
  YearMonth: string;
  /** Can be used as an argument to upload files using https://github.com/jaydenseric/graphql-multipart-request-spec */
  Upload: any;
  /** A datetime and timezone string in ISO 8601 format `Y-m-dTH:i:sO`, e.g. `2020-04-20T13:53:12+02:00`. */
  DateTimeTz: any;
};

export type Query = {
  adminAdmin: Admin;
  adminAdmins: AdminPaginator;
  adminPartnerApplication: PartnerApplication;
  adminPartnerApplications: PartnerApplicationPaginator;
  adminBilling: Billing;
  adminBillings: BillingPaginator;
  adminBillingMonths: BillingMonthPaginator;
  adminPartnerContracts: Array<PartnerContract>;
  adminValidPartnerContract?: Maybe<PartnerContract>;
  adminOrders: AdminOrderPaginator;
  order: Order;
  orderChanges: Array<Order>;
  adminOrderRefunds: Array<Refund>;
  adminDailySalesTrend: Array<DailySales>;
  adminMonthlySalesTrend: Array<MonthlySales>;
  adminAgentSalesOrders: AgentSalesOrderPaginator;
  adminAgentSalesOrder: AgentSalesOrder;
  adminAgentSalesSummaries: Array<AgentSalesSummary>;
  adminSubscription: SubscriptionBase;
  adminSubscriptions: SubscriptionPaginator;
  adminSubscriptionShippings: SubscriptionShippingPaginator;
  adminSubscriptionFixedHistories: SubscriptionFixedHistoryPagenator;
  adminDeliveryTimeCandidate: Array<DeliveryTimeCandidate>;
  adminCart: Cart;
  adminPartners: PartnerPaginator;
  adminPartner: Partner;
  adminMembers: MemberPaginator;
  adminMember?: Maybe<Member>;
  adminStoreShippingAddresses: Array<StoreShippingAddress>;
  adminStore: Store;
  adminStores: Array<Store>;
  adminStoreList: StorePaginator;
  adminPartnerBankAccounts: PartnerBankAccountPaginator;
  adminIndustries: IndustryPaginator;
  adminIndustry: Industry;
  goodsList: GoodsPaginator;
  adminGoods: Goods;
  menus: MenuPaginator;
  goodsSerieses: Array<GoodsSeries>;
  goodsSpecs: Array<GoodsSpec>;
  masterProducts: Array<FfbMasterProduct>;
  adminGoodsSpec: GoodsSpec;
  adminGoodsSpecs: GoodsSepecPaginator;
  adminGoodsSerieses: GoodsSeriesPaginator;
  adminDiscount: Discount;
  adminDiscounts: DiscountPaginator;
  adminDiscountCodes: DiscountCodePaginator;
  orderLimits: Array<OrderLimit>;
  searchOrderLimits?: Maybe<OrderLimitPaginator>;
  orderLimit: OrderLimit;
  adminManufactureDates?: Maybe<ManufactureDatePaginator>;
  adminOrderFulfillment: Array<OrderFulfillmentProcess>;
  adminOrderFulfillmentProcess: OrderFulfillmentProcess;
  adminGoodsSchedule: GoodsSchedule;
  adminGoodsSchedules: GoodsSchedulePaginator;
  adminSalesList: SalesPaginator;
  adminSales: Sales;
  adminFfServicePlans: Array<ServicePlan>;
  adminServiceProducts?: Maybe<Array<ServiceProduct>>;
  adminServicePlan: ServicePlan;
  adminShippingNumbers: Array<ShippingNumber>;
  /** @deprecated FFX出荷のリリース後、正式運用を経たのち削除。 TODO: DELETE OLD FFX */
  adminShippingSummariesOld?: Maybe<ShippingSummaryOldPaginator>;
  /** @deprecated FFX出荷のリリース後、正式運用を経たのち削除。 TODO: DELETE OLD FFX */
  adminShippingSummaryOld?: Maybe<ShippingSummaryOld>;
  /** @deprecated FFX出荷のリリース後、正式運用を経たのち削除。 TODO: DELETE OLD FFX */
  adminShippings?: Maybe<ShippingOldPaginator>;
  adminNearestShippingDate?: Maybe<Scalars['Date']>;
  adminSubscriptionNearestShippingDate?: Maybe<Scalars['Date']>;
  adminShippingItems?: Maybe<ShippingItemPaginator>;
  adminShippingSummaries?: Maybe<ShippingSummaryPaginator>;
  adminShippingSummary?: Maybe<ShippingSummary>;
  adminStock: Stock;
  adminStocks: StockPaginator;
  adminStockLogs: StockLogPaginator;
  adminWarehouses: Array<Warehouse>;
  adminMasterProduct: MasterProduct;
  adminMasterProducts: MasterProductPaginator;
  adminBatch: Batch;
  adminBatches?: Maybe<BatchPaginator>;
  adminLatestBatches: Array<Batch>;
  adminVersion: Versions;
  adminTransfer: Transfer;
  user: User;
  userShippingAddresses: Array<ShippingAddress>;
  adminSearchUsers?: Maybe<UserPaginator>;
  adminCreditCard?: Maybe<CreditCard>;
  affiliate?: Maybe<Affiliate>;
  totalAffiliate?: Maybe<TotalAffiliate>;
  retailAffiliate?: Maybe<Affiliate>;
  totalRetailAffiliate?: Maybe<TotalAffiliate>;
  authorizations: Array<Authorization>;
  validPartnerContract?: Maybe<PartnerContract>;
  validPartnerServiceContracts: Array<PartnerServiceContract>;
  partnerServiceContract: PartnerServiceContract;
  deliveryTimeCandidate: Array<DeliveryTimeCandidate>;
  cart: Cart;
  agentSalesOrderCart: AgentSalesCart;
  storeSalesOrders: StoreSalesOrderPaginator;
  agentSalesOrders: AgentSalesOrderPaginator;
  subscriptions: SubscriptionPaginator;
  partner: Partner;
  store: Store;
  stores: Array<Store>;
  storeShippingAddresses: StoreShippingAddressPaginator;
  allStoreShippingAddresses?: Maybe<Array<StoreShippingAddress>>;
  storeShippingAddress: StoreShippingAddress;
  storeOwners: MemberPaginator;
  storeOwner: Member;
  partnerBankAccount?: Maybe<PartnerBankAccount>;
  industries: Array<Industry>;
  salesProducts: Array<SalesProduct>;
  goodsMenus: Array<MenuSet>;
  discount: Discount;
  ffServicePlans: Array<ServicePlan>;
  nearestShippingDate?: Maybe<Scalars['Date']>;
  programDeliverySchedule?: Maybe<ProgramDeliverySchedule>;
  shippingRegion?: Maybe<ShippingRegion>;
  availableDeliveryCount: Array<AvailableDeliveryCount>;
  myPartner: Partner;
  myPartners: Array<Partner>;
  creditCardToken?: Maybe<CreditCardToken>;
  creditCard?: Maybe<CreditCard>;
  shippingAddresses: Array<ShippingAddress>;
  mainShippingAddress?: Maybe<ShippingAddress>;
  agentSalesDestinations: AgentSalesDestinationPaginator;
  agentSalesDestination: AgentSalesDestination;
};


export type QueryAdminAdminArgs = {
  loginId: Scalars['String'];
};


export type QueryAdminAdminsArgs = {
  input: AdminInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminPartnerApplicationArgs = {
  id: Scalars['ID'];
};


export type QueryAdminPartnerApplicationsArgs = {
  input: AdminPartnerApplicationsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminBillingArgs = {
  id: Scalars['ID'];
};


export type QueryAdminBillingsArgs = {
  input?: Maybe<AdminBillingsInput>;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminBillingMonthsArgs = {
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminPartnerContractsArgs = {
  partnerId: Scalars['ID'];
};


export type QueryAdminValidPartnerContractArgs = {
  partnerId: Scalars['ID'];
};


export type QueryAdminOrdersArgs = {
  input?: Maybe<AdminOrdersInput>;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryOrderArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderChangesArgs = {
  orderId: Scalars['ID'];
};


export type QueryAdminOrderRefundsArgs = {
  orderId: Scalars['ID'];
};


export type QueryAdminDailySalesTrendArgs = {
  standard?: Maybe<SalesStandard>;
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};


export type QueryAdminMonthlySalesTrendArgs = {
  standard?: Maybe<SalesStandard>;
  from?: Maybe<Scalars['YearMonth']>;
  to?: Maybe<Scalars['YearMonth']>;
};


export type QueryAdminAgentSalesOrdersArgs = {
  input?: Maybe<AdminAgentSalesOrdersInput>;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminAgentSalesOrderArgs = {
  id: Scalars['ID'];
};


export type QueryAdminAgentSalesSummariesArgs = {
  input?: Maybe<AdminAgentSalesSummariesInput>;
};


export type QueryAdminSubscriptionArgs = {
  subscriptionId: Scalars['ID'];
};


export type QueryAdminSubscriptionsArgs = {
  input: AdminSubscriptionInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminSubscriptionShippingsArgs = {
  subscriptionId: Scalars['ID'];
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminSubscriptionFixedHistoriesArgs = {
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminDeliveryTimeCandidateArgs = {
  input: DeliveryTimeCandidateInput;
};


export type QueryAdminCartArgs = {
  input: AdminCartInput;
};


export type QueryAdminPartnersArgs = {
  input: AdminPartnersInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminPartnerArgs = {
  id: Scalars['ID'];
};


export type QueryAdminMembersArgs = {
  input: AdminMembersInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminMemberArgs = {
  partnerId: Scalars['ID'];
  userId: Scalars['ID'];
};


export type QueryAdminStoreShippingAddressesArgs = {
  partnerId: Scalars['ID'];
};


export type QueryAdminStoreArgs = {
  id: Scalars['ID'];
};


export type QueryAdminStoresArgs = {
  input: AdminStoresInput;
};


export type QueryAdminStoreListArgs = {
  input: AdminStoresInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminPartnerBankAccountsArgs = {
  input: AdminPartnerBankAccountsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminIndustriesArgs = {
  input: AdminIndustriesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminIndustryArgs = {
  id: Scalars['ID'];
};


export type QueryGoodsListArgs = {
  input: GoodsListInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminGoodsArgs = {
  id: Scalars['ID'];
};


export type QueryMenusArgs = {
  input: MenuListInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminGoodsSpecArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGoodsSpecsArgs = {
  input: AdminGoodsSpecsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminGoodsSeriesesArgs = {
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminDiscountArgs = {
  id: Scalars['ID'];
};


export type QueryAdminDiscountsArgs = {
  input: AdminDiscountsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminDiscountCodesArgs = {
  input: AdminDiscountCodesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryOrderLimitsArgs = {
  input: OrderLimitsInput;
};


export type QuerySearchOrderLimitsArgs = {
  input: SearchOrderLimitsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryOrderLimitArgs = {
  id: Scalars['ID'];
};


export type QueryAdminManufactureDatesArgs = {
  first: Scalars['Int'];
  page: Scalars['Int'];
};


export type QueryAdminOrderFulfillmentArgs = {
  input: AdminOrderFulfillmentInput;
};


export type QueryAdminOrderFulfillmentProcessArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGoodsScheduleArgs = {
  id: Scalars['ID'];
};


export type QueryAdminGoodsSchedulesArgs = {
  input: AdminGoodsSchedulesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminSalesListArgs = {
  input: AdminSalesListInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminSalesArgs = {
  input: AdminSalesInput;
};


export type QueryAdminServiceProductsArgs = {
  input: AdminServiceProductsInput;
};


export type QueryAdminServicePlanArgs = {
  id: Scalars['ID'];
};


export type QueryAdminShippingNumbersArgs = {
  orderId: Scalars['ID'];
};


export type QueryAdminShippingSummariesOldArgs = {
  input: AdminShippingSummariesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminShippingSummaryOldArgs = {
  shippingDate: Scalars['Date'];
};


export type QueryAdminShippingsArgs = {
  input: AdminShippingsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminNearestShippingDateArgs = {
  input: NearestShippingDateInput;
};


export type QueryAdminShippingItemsArgs = {
  input: AdminShippingItemsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminShippingSummariesArgs = {
  input: AdminShippingSummariesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminShippingSummaryArgs = {
  shippingDate: Scalars['Date'];
};


export type QueryAdminStockArgs = {
  id: Scalars['ID'];
};


export type QueryAdminStocksArgs = {
  input: AdminStocksInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminStockLogsArgs = {
  input: AdminStockLogsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminMasterProductArgs = {
  id: Scalars['ID'];
};


export type QueryAdminMasterProductsArgs = {
  input: AdminMasterProductsInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminBatchArgs = {
  id: Scalars['ID'];
};


export type QueryAdminBatchesArgs = {
  input: AdminBatchesInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminTransferArgs = {
  input: AdminTransferInput;
};


export type QueryUserArgs = {
  userId: Scalars['ID'];
};


export type QueryUserShippingAddressesArgs = {
  userId: Scalars['ID'];
};


export type QueryAdminSearchUsersArgs = {
  input?: Maybe<AdminUserSearchInput>;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAdminCreditCardArgs = {
  userId: Scalars['ID'];
};


export type QueryAffiliateArgs = {
  input: AffiliateInput;
};


export type QueryTotalAffiliateArgs = {
  input: TotalAffiliateInput;
};


export type QueryRetailAffiliateArgs = {
  input: AffiliateInput;
};


export type QueryTotalRetailAffiliateArgs = {
  input: TotalAffiliateInput;
};


export type QueryAuthorizationsArgs = {
  partnerId?: Maybe<Scalars['ID']>;
};


export type QueryValidPartnerContractArgs = {
  partnerId: Scalars['ID'];
};


export type QueryValidPartnerServiceContractsArgs = {
  baseDate?: Maybe<Scalars['Date']>;
};


export type QueryPartnerServiceContractArgs = {
  id: Scalars['ID'];
};


export type QueryDeliveryTimeCandidateArgs = {
  input: DeliveryTimeCandidateInput;
};


export type QueryCartArgs = {
  input: CartInput;
};


export type QueryAgentSalesOrderCartArgs = {
  input: AgentSalesCartInput;
};


export type QueryStoreSalesOrdersArgs = {
  input: StoreSalesOrdersInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAgentSalesOrdersArgs = {
  input: AgentSalesOrdersInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QuerySubscriptionsArgs = {
  input: SubscriptionInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryPartnerArgs = {
  partnerId: Scalars['ID'];
};


export type QueryStoreArgs = {
  storeId: Scalars['ID'];
};


export type QueryStoresArgs = {
  input: StoresInput;
};


export type QueryStoreShippingAddressesArgs = {
  partnerId: Scalars['ID'];
  storeId: Scalars['ID'];
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAllStoreShippingAddressesArgs = {
  storeId: Scalars['ID'];
};


export type QueryStoreShippingAddressArgs = {
  partnerId: Scalars['ID'];
  id: Scalars['ID'];
};


export type QueryStoreOwnersArgs = {
  input: StoreOwnersInput;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryStoreOwnerArgs = {
  input: StoreOwnerInput;
};


export type QueryPartnerBankAccountArgs = {
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
};


export type QuerySalesProductsArgs = {
  input: SalesProductsInput;
};


export type QueryGoodsMenusArgs = {
  goodsSpecId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
};


export type QueryDiscountArgs = {
  discountId: Scalars['ID'];
};


export type QueryNearestShippingDateArgs = {
  input: NearestShippingDateInput;
};


export type QueryProgramDeliveryScheduleArgs = {
  input: ProgramDeliveryScheduleInput;
};


export type QueryShippingRegionArgs = {
  zipCode: Scalars['String'];
};


export type QueryMyPartnerArgs = {
  partnerId: Scalars['ID'];
};


export type QueryShippingAddressesArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type QueryAgentSalesDestinationsArgs = {
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
  first: Scalars['Int'];
  page?: Maybe<Scalars['Int']>;
};


export type QueryAgentSalesDestinationArgs = {
  partnerId: Scalars['ID'];
  id: Scalars['ID'];
};

export type Admin = {
  loginId: Scalars['String'];
  email: Scalars['String'];
  name: PersonName;
};

export type PersonName = {
  first: Scalars['String'];
  last: Scalars['String'];
  fullName: Scalars['String'];
};

export type AdminInput = {
  email?: Maybe<Scalars['String']>;
};

export type AdminPaginator = {
  data: Array<Admin>;
  paginatorInfo: PaginatorInfo;
};

/** Information about pagination using a fully featured paginator. */
export type PaginatorInfo = {
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Number of total available items. */
  total: Scalars['Int'];
};

export type PartnerApplication = {
  partnerApplicationId: Scalars['ID'];
  applicantName: PersonName;
  applicantEmail: Scalars['String'];
  useAffiliate: Scalars['Boolean'];
  servicePlanIds?: Maybe<Array<Scalars['ID']>>;
  appliedAt: Scalars['DateTime'];
  status: ApplicationStatus;
  companyName: Scalars['String'];
  ownerName: Scalars['String'];
  address: Address;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  referrer?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['ID']>;
  storeApplications: Array<StoreApplication>;
  servicePlans?: Maybe<Array<ServicePlan>>;
  partner?: Maybe<Partner>;
};


export enum ApplicationStatus {
  Open = 'OPEN',
  UnderReview = 'UNDER_REVIEW',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type Address = {
  zipCode: ZipCode;
  pref: Pref;
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  fullAddress: Scalars['String'];
};

export type ZipCode = {
  first: Scalars['String'];
  second: Scalars['String'];
  fullCode: Scalars['String'];
};

export type Pref = {
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type StoreApplication = {
  storeApplicationId: Scalars['ID'];
  name: Scalars['String'];
  address: Address;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  industryId: Scalars['ID'];
  industryFreeWord?: Maybe<Scalars['String']>;
  industry: Industry;
};

export type Industry = {
  industryId: Scalars['ID'];
  name: Scalars['String'];
  isVisible: Scalars['Boolean'];
  pos: Scalars['Int'];
};

export type ServicePlan = {
  servicePlanId: Scalars['ID'];
  partnerId: Scalars['String'];
  name: Scalars['String'];
  serviceCode: Scalars['String'];
  primaryColor: Scalars['String'];
  logo?: Maybe<Image>;
  type: ServicePlanType;
  serviceProducts?: Maybe<Array<ServiceProduct>>;
};

export type Image = File & {
  path?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  mimetype?: Maybe<Scalars['String']>;
  encoding?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  thumbnails?: Maybe<Thumbnail>;
};

export type File = {
  path?: Maybe<Scalars['String']>;
  filename?: Maybe<Scalars['String']>;
  mimetype?: Maybe<Scalars['String']>;
  encoding?: Maybe<Scalars['String']>;
};

export type Thumbnail = {
  sm?: Maybe<Image>;
  md?: Maybe<Image>;
  lg?: Maybe<Image>;
};

export enum ServicePlanType {
  StoreSales = 'StoreSales',
  AgentSales = 'AgentSales',
  Other = 'Other'
}

export type ServiceProduct = {
  type: ServiceProductType;
  serviceProductId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
};

export enum ServiceProductType {
  Product = 'Product',
  GoodsSeries = 'GoodsSeries'
}


export type Partner = {
  partnerId: Scalars['ID'];
  parentPartnerId?: Maybe<Scalars['ID']>;
  isRoyal: Scalars['Boolean'];
  companyName: Scalars['String'];
  name: Scalars['String'];
  ownerName: Scalars['String'];
  address: Address;
  location: Location;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  type: PartnerType;
  partnerCode: Scalars['String'];
  paymentMethod: PaymentMethod;
  registrationUrl?: Maybe<Scalars['String']>;
  partnntMethod: PaymentMethod;
  storeOwnerRegistrationUrl?: Maybe<Scalars['String']>;
  logo?: Maybe<Image>;
  bankTransferType: BankTransferType;
};

export type Location = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export enum PartnerType {
  FfPartners = 'FfPartners',
  General = 'General'
}

export enum PaymentMethod {
  Credit = 'CREDIT',
  Bank = 'BANK',
  Np = 'NP'
}

export enum BankTransferType {
  Partner = 'Partner',
  Store = 'Store'
}

export type AdminPartnerApplicationsInput = {
  companyName?: Maybe<Scalars['String']>;
  status?: Maybe<ApplicationStatus>;
};

export type PartnerApplicationPaginator = {
  data: Array<PartnerApplication>;
  paginatorInfo: PaginatorInfo;
};

export type Billing = {
  billingId: Scalars['ID'];
  billingNo: Scalars['String'];
  partnerId: Scalars['ID'];
  yearMonth: Scalars['YearMonth'];
  sentToUser: Scalars['Boolean'];
  isVerified: Scalars['Boolean'];
  totalPriceIncludeTax: Scalars['Int'];
  totalTaxAmount: Scalars['Int'];
  totalTaxAmountsByRate: Array<TaxAmountByRate>;
  totalRefundAmountIncludeTax: Scalars['Int'];
  billingItems: Array<BillingItem>;
  billingRefundItems: Array<BillingRefundItem>;
  formUrl: Scalars['String'];
  partner?: Maybe<Partner>;
};


export type TaxAmountByRate = {
  taxRate: Scalars['Int'];
  amount: Scalars['Int'];
};

export type BillingItem = {
  billingItemId: Scalars['ID'];
  billingId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  productId: Scalars['ID'];
  unitPrice: Scalars['Int'];
  tax: Scalars['Int'];
  quantity: Scalars['Int'];
  totalPrice: Scalars['Int'];
  totalPriceIncludeTax: Scalars['Int'];
  totalTaxAmount: Scalars['Int'];
  servicePlan?: Maybe<ServicePlan>;
  product?: Maybe<Goods>;
};

export type Goods = FfGoods;

export type FfGoods = Product & {
  /**  商品情報  */
  productId: Scalars['ID'];
  price: Price;
  type: ProductType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Image>;
  published: Scalars['Boolean'];
  masterProductId?: Maybe<Scalars['ID']>;
  masterProduct?: Maybe<MasterProduct>;
  /**
   *  物理商品情報 
   * @deprecated Use the `productId` field
   */
  goodId: Scalars['ID'];
  goodsSpecId: Scalars['ID'];
  goodsSpec: GoodsSpec;
  goodsType: GoodsType;
  setQuantity: Scalars['Int'];
  manufactureUnit?: Maybe<Scalars['Int']>;
  /** @deprecated 移行後削除 */
  goodsSeriesId?: Maybe<Scalars['ID']>;
};

export type Product = {
  productId: Scalars['ID'];
  price: Price;
  type: ProductType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Image>;
  published: Scalars['Boolean'];
  masterProductId?: Maybe<Scalars['ID']>;
};

export type Price = {
  /** 総額(割引込み・税込み) */
  gross: Scalars['Int'];
  /** 割引額 */
  discount: Scalars['Int'];
  /** 税額 */
  tax: Scalars['Int'];
  /** 定価(割引抜き・税抜き) */
  list: Scalars['Int'];
  /** 価格(割引込み・税抜き) */
  net: Scalars['Int'];
};

export enum ProductType {
  Goods = 'Goods',
  Program = 'Program',
  Service = 'Service'
}

export type MasterProduct = {
  masterProductId: Scalars['ID'];
  code: Scalars['String'];
  products?: Maybe<Array<Product>>;
};

export type GoodsSpec = {
  goodsSpecId: Scalars['ID'];
  goodsSeriesId: Scalars['ID'];
  name: Scalars['String'];
  goodsSeries: GoodsSeries;
};

export type GoodsSeries = {
  goodsSeriesId: Scalars['ID'];
  name: Scalars['String'];
};

export enum GoodsType {
  Ff = 'Ff',
  FfAgent = 'FfAgent'
}

export type BillingRefundItem = {
  billingRefundItemId: Scalars['ID'];
  billingId: Scalars['ID'];
  refundId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  amount: Scalars['Int'];
  tax: Scalars['Int'];
  reason: Scalars['String'];
  refundedAt: Scalars['DateTime'];
  totalAmountIncludeTax: Scalars['Int'];
  servicePlan?: Maybe<ServicePlan>;
  refund?: Maybe<Refund>;
};

export type Refund = {
  refundId: Scalars['ID'];
  orderId: Scalars['ID'];
  orderItemId?: Maybe<Scalars['ID']>;
  amount: Scalars['Int'];
  includeTaxAmount: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
  refundedAt: Scalars['DateTime'];
  adminId?: Maybe<Scalars['String']>;
};

export type AdminBillingsInput = {
  yearMonth?: Maybe<Scalars['YearMonth']>;
  partnerCode?: Maybe<Scalars['String']>;
  sentToUser?: Maybe<Scalars['Boolean']>;
  isVerified?: Maybe<Scalars['Boolean']>;
};

export type BillingPaginator = {
  data: Array<Billing>;
  paginatorInfo: PaginatorInfo;
};

export type BillingMonthPaginator = {
  data: Array<BillingMonth>;
  paginatorInfo: PaginatorInfo;
};

export type BillingMonth = {
  yearMonth: Scalars['YearMonth'];
};

export type PartnerContract = {
  partnerContractId: Scalars['ID'];
  partnerId: Scalars['ID'];
  useAffiliate: Scalars['Boolean'];
  startedAt: Scalars['Date'];
  finishedAt?: Maybe<Scalars['Date']>;
  status: PartnerContractStatus;
  serviceContracts?: Maybe<Array<PartnerServiceContract>>;
};

export enum PartnerContractStatus {
  Ongoing = 'Ongoing',
  Finished = 'Finished'
}

export type PartnerServiceContract = {
  partnerServiceContractId: Scalars['ID'];
  partnerId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  status: ServiceContractStatus;
  productContracts?: Maybe<Array<ProductContract>>;
  servicePlan?: Maybe<ServicePlan>;
  partner?: Maybe<Partner>;
};

export enum ServiceContractStatus {
  Applying = 'Applying',
  Approved = 'Approved',
  Terminated = 'Terminated'
}

export type ProductContract = {
  partnerServiceContractId: Scalars['ID'];
  serviceProductId: Scalars['ID'];
  serviceProduct?: Maybe<ServiceProduct>;
};

export type AdminOrdersInput = {
  userId?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameKana?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNo?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<OrderStatus>>;
  shippingDate?: Maybe<DateRange>;
  orderedDate?: Maybe<DateRange>;
  cancelDate?: Maybe<DateRange>;
  refundDate?: Maybe<DateRange>;
  servicePlanId?: Maybe<Scalars['ID']>;
  salesChannel?: Maybe<SalesChannel>;
  recipientPhone?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  New = 'NEW',
  Fixed = 'FIXED',
  ReadyToShip = 'READY_TO_SHIP',
  Shipped = 'SHIPPED',
  Cancelled = 'CANCELLED'
}

export type DateRange = {
  from?: Maybe<Scalars['Date']>;
  to?: Maybe<Scalars['Date']>;
};

export enum SalesChannel {
  Web = 'Web',
  Tel = 'Tel',
  Fax = 'Fax'
}

export type AdminOrderPaginator = {
  orderPaginator: OrderPaginator;
  orderExcelUrl: Scalars['String'];
  orderItemExcelUrl: Scalars['String'];
};

export type OrderPaginator = {
  data: Array<Order>;
  paginatorInfo: PaginatorInfo;
  orderCsvUrl: Scalars['String'];
  orderItemCsvUrl: Scalars['String'];
};

export type Order = {
  orderId: Scalars['ID'];
  salesChannel: SalesChannel;
  userId: Scalars['String'];
  consumerPartnerId?: Maybe<Scalars['ID']>;
  consumerStoreId?: Maybe<Scalars['ID']>;
  orderNo: Scalars['String'];
  paymentMethod: PaymentMethod;
  status: OrderStatus;
  shippingDate: Scalars['Date'];
  shippingAddress: Address;
  destinationName: Scalars['String'];
  recipientName?: Maybe<PersonName>;
  recipientPhone: Scalars['String'];
  recipientEmail?: Maybe<Scalars['String']>;
  shippingCompanyDepartment?: Maybe<Scalars['String']>;
  deliveryTime: DeliveryTime;
  npTransactionId?: Maybe<Scalars['String']>;
  orderedAt: Scalars['DateTime'];
  canceledAt?: Maybe<Scalars['DateTime']>;
  totalQuantity: Scalars['Int'];
  paymentFee: Price;
  shippingFee: Price;
  price: Price;
  totalPrice: Price;
  orderItems: Array<OrderItem>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  canCancel: Scalars['Boolean'];
  canChangeDeliveryTime: Scalars['Boolean'];
  user?: Maybe<User>;
  partner?: Maybe<Partner>;
  store?: Maybe<Store>;
  fixedDate?: Maybe<Scalars['Date']>;
};

export type DeliveryTime = {
  date?: Maybe<Scalars['Date']>;
  timeSlot: DeliveryTimeSlot;
};

export type DeliveryTimeSlot = {
  code: Scalars['Int'];
  label: Scalars['String'];
};

export type OrderItem = {
  orderItemId: Scalars['ID'];
  seriesId?: Maybe<Scalars['ID']>;
  seriesName?: Maybe<Scalars['ID']>;
  productId: Scalars['ID'];
  goodId?: Maybe<Scalars['ID']>;
  fulfillmentProcessId?: Maybe<Scalars['ID']>;
  productCode: Scalars['String'];
  productName: Scalars['String'];
  orderQuantity: Scalars['Int'];
  productPrice: Scalars['Int'];
  /** @deprecated use price instead */
  productPriceIncludeTax: Scalars['Int'];
  price: Price;
  discountIds?: Maybe<Array<Scalars['ID']>>;
  productLots: Array<ProductLot>;
  menuSets?: Maybe<Array<MenuSet>>;
  ffGoods: FfGoods;
  discounts?: Maybe<Array<Discount>>;
  reservedStocks?: Maybe<Array<StockQuantity>>;
};

export type ProductLot = {
  fulfillmentProcessId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type MenuSet = {
  menuSetId: Scalars['ID'];
  goodsScheduleId: Scalars['ID'];
  menuId: Scalars['ID'];
  quantity: Scalars['Int'];
  pos: Scalars['Int'];
  menu: Menu;
};

export type Menu = {
  menuId: Scalars['ID'];
  menuName: Scalars['String'];
  catchPhrase?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  dishes?: Maybe<Array<Dish>>;
  allergens?: Maybe<Array<Allergen>>;
  additives?: Maybe<Array<Additive>>;
};

export type Dish = {
  dishId: Scalars['ID'];
  name: Scalars['String'];
  materials: Array<Material>;
  allergens: Array<Allergen>;
  additives: Array<Additive>;
};

export type Material = {
  materialId: Scalars['ID'];
  name: Scalars['String'];
  allergens: Array<Allergen>;
};

export type Allergen = {
  allergenId: Scalars['ID'];
  name: Scalars['String'];
};

export type Additive = {
  additiveId: Scalars['ID'];
  name: Scalars['String'];
};

export type Discount = {
  discountId: Scalars['ID'];
  type: DiscountType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  endsAt?: Maybe<Scalars['DateTime']>;
  discountRate?: Maybe<Scalars['Float']>;
  isExclusive: Scalars['Boolean'];
  isCodeRequired: Scalars['Boolean'];
  actionKey?: Maybe<DiscountTriggerAction>;
  constraints: Array<DiscountConstraint>;
  isAvailable: Scalars['Boolean'];
};

export enum DiscountType {
  Rate = 'Rate'
}

export enum DiscountTriggerAction {
  InitialOrderAs = 'InitialOrderAS',
  AgentSubscription = 'AgentSubscription'
}

export type DiscountConstraint = {
  discountConstraintId: Scalars['ID'];
  discountId: Scalars['ID'];
  type: DiscountConstraintType;
  productIds?: Maybe<Array<Scalars['ID']>>;
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  maxUseCount?: Maybe<Scalars['Int']>;
  maxItemQuantity?: Maybe<Scalars['Int']>;
  maxDiscountRate?: Maybe<Scalars['Float']>;
  products?: Maybe<Array<Goods>>;
  partners?: Maybe<Array<Partner>>;
};

export enum DiscountConstraintType {
  Product = 'Product',
  Partner = 'Partner',
  MaxUseCount = 'MaxUseCount',
  MaxItemQuantity = 'MaxItemQuantity',
  MaxDiscountRate = 'MaxDiscountRate'
}

export type StockQuantity = {
  warehouseId: Scalars['ID'];
  masterProductId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  quantity: Scalars['Int'];
  stock?: Maybe<Stock>;
};

export type Stock = {
  stockId: Scalars['ID'];
  warehouseId: Scalars['ID'];
  masterProductId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  quantity: Scalars['Int'];
  reservedQuantity: Scalars['Int'];
  shippedQuantity: Scalars['Int'];
  futureQuantity: Scalars['Int'];
  reservedFutureQuantity: Scalars['Int'];
  securedQuantity: Scalars['Int'];
  availableQuantity: Scalars['Int'];
  warehouse?: Maybe<Warehouse>;
  masterProduct?: Maybe<MasterProduct>;
  fulfillmentProcess?: Maybe<OrderFulfillmentProcess>;
  /** @deprecated 未使用であることを確認後削除 */
  stockLogs?: Maybe<Array<StockLog>>;
};

export type Warehouse = {
  warehouseId: Scalars['ID'];
  name: Scalars['String'];
  code: Scalars['String'];
};

export type OrderFulfillmentProcess = {
  id: Scalars['ID'];
  code?: Maybe<Scalars['String']>;
  events: Array<OrderFulfillmentEvent>;
};

export type OrderFulfillmentEvent = {
  type: OrderFulfillmentEventType;
  from: Scalars['DateTime'];
  to?: Maybe<Scalars['DateTime']>;
  isAllDay: Scalars['Boolean'];
};

export enum OrderFulfillmentEventType {
  Order = 'Order',
  FixOrder = 'FixOrder',
  Produce = 'Produce',
  FixDelivery = 'FixDelivery',
  Ship = 'Ship'
}

export type StockLog = {
  stockLogId: Scalars['ID'];
  stockId: Scalars['ID'];
  type: StockEventType;
  quantities: StockLogQuantities;
  createdAt: Scalars['DateTime'];
  createdBy: Runner;
};

export enum StockEventType {
  FutureStored = 'FutureStored',
  Stored = 'Stored',
  Reserved = 'Reserved',
  ReserveCanceled = 'ReserveCanceled',
  Shipped = 'Shipped',
  StockChanged = 'StockChanged'
}

export type StockLogQuantities = {
  quantity: Scalars['Int'];
  reservedQuantity: Scalars['Int'];
  shippedQuantity: Scalars['Int'];
  futureQuantity: Scalars['Int'];
  reservedFutureQuantity: Scalars['Int'];
  securedQuantity: Scalars['Int'];
};

export type Runner = {
  type: RunnerType;
  code: Scalars['String'];
};

export enum RunnerType {
  Admin = 'Admin',
  User = 'User',
  Command = 'Command',
  System = 'System'
}

export type User = {
  userId: Scalars['ID'];
  email: Scalars['String'];
  emailVerified: Scalars['Boolean'];
  profile: Profile;
  createdAt: Scalars['DateTime'];
  members?: Maybe<Array<Member>>;
};

export type Profile = {
  id: Scalars['ID'];
  userId: Scalars['ID'];
  /** @deprecated Use the `name` field */
  firstName: Scalars['String'];
  /** @deprecated Use the `name` field */
  lastName: Scalars['String'];
  /** @deprecated Use the `nameKana` field */
  firstNameKana: Scalars['String'];
  /** @deprecated Use the `nameKana` field */
  lastNameKana: Scalars['String'];
  birthday?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  name: PersonName;
  nameKana: PersonName;
};

export type Member = {
  memberId: Scalars['ID'];
  partnerId: Scalars['ID'];
  userId: Scalars['ID'];
  type?: Maybe<MemberType>;
  externalId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  partner?: Maybe<Partner>;
  stores?: Maybe<Array<Store>>;
};

export enum MemberType {
  Individual = 'Individual',
  Owner = 'Owner',
  StoreOwner = 'StoreOwner'
}

export type Store = {
  storeId: Scalars['ID'];
  partnerId: Scalars['ID'];
  name: Scalars['String'];
  storeCode: Scalars['String'];
  affiliateId?: Maybe<Scalars['ID']>;
  address: Address;
  location: Location;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  industryId?: Maybe<Scalars['ID']>;
  bankAccount?: Maybe<PartnerBankAccount>;
  industry?: Maybe<Industry>;
};

export type PartnerBankAccount = {
  partnerBankAccountId: Scalars['ID'];
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
  bankName: Scalars['String'];
  branchNumber: Scalars['String'];
  branchName: Scalars['String'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: AccountType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  partner?: Maybe<Partner>;
  store?: Maybe<Store>;
};

export enum AccountType {
  Savings = 'Savings',
  Current = 'Current',
  Others = 'Others'
}

export enum SalesStandard {
  Shipping = 'SHIPPING',
  Order = 'ORDER'
}

export type DailySales = {
  date: Scalars['Date'];
  totalAmount: Scalars['Int'];
  fixedAmount: Scalars['Int'];
  salesExpectedAmount: Scalars['Int'];
  orderExpectedAmount: Scalars['Int'];
};

export type MonthlySales = {
  yearMonth: Scalars['YearMonth'];
  totalAmount: Scalars['Int'];
  fixedAmount: Scalars['Int'];
  salesExpectedAmount: Scalars['Int'];
  orderExpectedAmount: Scalars['Int'];
};

export type AdminAgentSalesOrdersInput = {
  email?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
  userNameKana?: Maybe<Scalars['String']>;
  partnerName?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  statuses?: Maybe<Array<AgentSalesOrderStatus>>;
  orderNo?: Maybe<Scalars['String']>;
  orderedDate?: Maybe<DateRange>;
};

export enum AgentSalesOrderStatus {
  New = 'NEW',
  Charged = 'CHARGED',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED'
}

export type AgentSalesOrderPaginator = {
  data: Array<AgentSalesOrder>;
  paginatorInfo: PaginatorInfo;
};

export type AgentSalesOrder = {
  agentSalesOrderId: Scalars['ID'];
  consumerPartnerId: Scalars['ID'];
  consumerStoreId?: Maybe<Scalars['ID']>;
  consumerUserId: Scalars['ID'];
  orderNo: Scalars['String'];
  paymentMethod: PaymentMethod;
  status: AgentSalesOrderStatus;
  recipient: AgentSalesOrderRecipient;
  deliveryOptions: AgentSalesOrderDeliveryOptions;
  orderedAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  orderItems: Array<AgentSalesOrderItem>;
  /** @deprecated use price instead */
  totalPrice: Scalars['Int'];
  /** @deprecated use price instead */
  totalPriceIncludeTax: Scalars['Int'];
  price: Price;
  consumerPartner?: Maybe<Partner>;
  consumerStore?: Maybe<Store>;
  consumerUser?: Maybe<User>;
  paymentChargeId?: Maybe<Scalars['String']>;
  chargeAmount?: Maybe<Scalars['Int']>;
  chargeMemo?: Maybe<Scalars['String']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  cancelMemo?: Maybe<Scalars['String']>;
};

export type AgentSalesOrderRecipient = {
  name: PersonName;
  nameKana: PersonName;
  address: Address;
  phone: Scalars['String'];
  email: Scalars['String'];
};

export type AgentSalesOrderDeliveryOptions = {
  deliveryFrequency: DeliveryFrequency;
  numberOfDeliveries: Scalars['Int'];
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: Scalars['Int'];
};

export enum DeliveryFrequency {
  EveryWeek = 'EVERY_WEEK',
  EveryOtherWeek = 'EVERY_OTHER_WEEK'
}

export enum XDayOfWeek {
  Sunday = 'SUNDAY',
  Monday = 'MONDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY',
  Thursday = 'THURSDAY',
  Friday = 'FRIDAY',
  Saturday = 'SATURDAY'
}

export type AgentSalesOrderItem = {
  agentSalesOrderItemId: Scalars['ID'];
  servicePlanId?: Maybe<Scalars['ID']>;
  productId: Scalars['String'];
  productCode?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  quantity: Scalars['Int'];
  productPrice: Scalars['Int'];
  /** @deprecated use price instead */
  productPriceIncludeTax: Scalars['Int'];
  price: Price;
  shippingItems: Array<AgentSalesShippingItem>;
  product?: Maybe<Product>;
};

export type AgentSalesShippingItem = {
  id: Scalars['ID'];
  deliveryTime: DeliveryTime;
  shippingStatus: AgentSalesShippingItemStatus;
  /** @deprecated to be removed */
  ffhOrderDeadlineDate?: Maybe<Scalars['Date']>;
  /** @deprecated to be removed */
  ffhOrderDate?: Maybe<Scalars['Date']>;
  /** @deprecated to be removed */
  ffhProductCode?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  discountIds?: Maybe<Array<Scalars['ID']>>;
  fixedDateToShip: Scalars['Date'];
  reservedStocks?: Maybe<Array<StockQuantity>>;
  order?: Maybe<Order>;
  discounts?: Maybe<Array<Discount>>;
};

export enum AgentSalesShippingItemStatus {
  New = 'New',
  Ordered = 'Ordered',
  Fixed = 'Fixed',
  Failed = 'Failed',
  Canceled = 'Canceled'
}

export type AdminAgentSalesSummariesInput = {
  fulfillmentProcessId?: Maybe<Scalars['ID']>;
};

export type AgentSalesSummary = {
  masterProductId: Scalars['ID'];
  agentSalesShippingDateSummaries: Array<AgentSalesShippingDateSummary>;
  masterProduct: MasterProduct;
};

export type AgentSalesShippingDateSummary = {
  shippingDate: Scalars['Date'];
  totalOrderQuantity: Scalars['Int'];
  totalAvailableQuantity: Scalars['Int'];
  stocked: Scalars['Boolean'];
};

export type SubscriptionBase = {
  subscriptionId: Scalars['ID'];
  salesChannel: SalesChannel;
  consumerPartnerId: Scalars['ID'];
  consumerStoreId: Scalars['ID'];
  consumerUserId: Scalars['ID'];
  providerPartnerId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  applicationNo: Scalars['String'];
  applicationDate: Scalars['Date'];
  status: SubscriptionStatus;
  paymentMethod: PaymentMethod;
  recipientAddress: Address;
  recipientName: PersonName;
  recipientKanaName: PersonName;
  recipientPhoneNumber: Scalars['String'];
  recipientEmail?: Maybe<Scalars['String']>;
  deliveryFrequency: DeliveryFrequency;
  numberOfDelivery?: Maybe<Scalars['Int']>;
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: DeliveryTimeSlot;
  firstShippingDate?: Maybe<Scalars['Date']>;
  finishReason?: Maybe<FinishReason>;
  finishedAt?: Maybe<Scalars['DateTime']>;
  subscriptionItems: Array<SubscriptionItem>;
  consumerPartner: Partner;
  consumerStore: Store;
  consumerUser: User;
};

export enum SubscriptionStatus {
  BeforeContract = 'BeforeContract',
  Contracted = 'Contracted',
  Finished = 'Finished'
}

export enum FinishReason {
  Normal = 'Normal',
  ReserveFailure = 'ReserveFailure',
  NpExaminationNg = 'NpExaminationNG'
}

export type SubscriptionItem = {
  subscriptionItemId: Scalars['ID'];
  subscriptionId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  product: Product;
};

export type AdminSubscriptionInput = {
  partnerCode?: Maybe<Scalars['String']>;
  applicationNo?: Maybe<Scalars['String']>;
  applicationDate?: Maybe<DateRange>;
  name?: Maybe<Scalars['String']>;
  kanaName?: Maybe<Scalars['String']>;
  salesChannel?: Maybe<SalesChannel>;
  statuses?: Maybe<Array<SubscriptionStatus>>;
};

export type SubscriptionPaginator = {
  data: Array<SubscriptionBase>;
  paginatorInfo: PaginatorInfo;
};

export type SubscriptionShippingPaginator = {
  data: Array<SubscriptionShipping>;
  paginatorInfo: PaginatorInfo;
};

export type SubscriptionShipping = {
  subscriptionShippingId: Scalars['ID'];
  subscriptionId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  deliveryTime: DeliveryTime;
  items: Array<SubscriptionShippingItem>;
};

export type SubscriptionShippingItem = {
  subscriptionShippingItemId: Scalars['ID'];
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  orderId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  product?: Maybe<Product>;
};

export type SubscriptionFixedHistoryPagenator = {
  data: Array<SubscriptionFixedHistory>;
  paginatorInfo: PaginatorInfo;
};

export type SubscriptionFixedHistory = {
  subscriptionFixedHistoryId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  fixedAt: Scalars['DateTime'];
  createdBy?: Maybe<Runner>;
  admin?: Maybe<Admin>;
};

export type DeliveryTimeCandidateInput = {
  zipCode: Scalars['String'];
  shippingDate?: Maybe<Scalars['Date']>;
};

export type DeliveryTimeCandidate = {
  date: Scalars['Date'];
  deliveryTimeSlots: Array<DeliveryTimeSlot>;
};

export type AdminCartInput = {
  orderItems: Array<AdminCartItemInput>;
};

export type AdminCartItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type Cart = {
  date: Scalars['Date'];
  pricing: Pricing;
  items: Array<CartItem>;
};

export type Pricing = {
  /** 価格 */
  price: Price;
  /** 手数料 */
  payment: Price;
  /** 送料 */
  shipping: Price;
  /** 総額 */
  total: Price;
};

export type CartItem = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
  unitPrice: Price;
  price: Price;
};

export type AdminPartnersInput = {
  partnerId?: Maybe<Scalars['ID']>;
  companyName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['Int']>;
  partnerCode?: Maybe<Scalars['String']>;
  contractedServicePlanId?: Maybe<Scalars['ID']>;
  isRoyal?: Maybe<Scalars['Boolean']>;
  hasMember?: Maybe<Scalars['Boolean']>;
  useAffiliate?: Maybe<Scalars['Boolean']>;
};

export type PartnerPaginator = {
  data: Array<Partner>;
  paginatorInfo: PaginatorInfo;
};

export type AdminMembersInput = {
  partnerId?: Maybe<Scalars['ID']>;
  storeId?: Maybe<Scalars['ID']>;
};

export type MemberPaginator = {
  data: Array<Member>;
  paginatorInfo: PaginatorInfo;
};

export type StoreShippingAddress = {
  storeShippingAddressId: Scalars['ID'];
  storeId: Scalars['String'];
  name: Scalars['String'];
  destinationName: Scalars['String'];
  address: Address;
  phone?: Maybe<Scalars['String']>;
  companyDepartment?: Maybe<Scalars['String']>;
  main: Scalars['Boolean'];
  store?: Maybe<Store>;
};

export type AdminStoresInput = {
  partnerId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type StorePaginator = {
  data: Array<Store>;
  paginatorInfo: PaginatorInfo;
};

export type AdminPartnerBankAccountsInput = {
  partnerName?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  storeCode?: Maybe<Scalars['String']>;
};

export type PartnerBankAccountPaginator = {
  data: Array<PartnerBankAccount>;
  paginatorInfo: PaginatorInfo;
};

export type AdminIndustriesInput = {
  industryId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  isVisible?: Maybe<Scalars['Boolean']>;
};

export type IndustryPaginator = {
  data: Array<Industry>;
  paginatorInfo: PaginatorInfo;
};

export type GoodsListInput = {
  name?: Maybe<Scalars['String']>;
  goodsSpecId?: Maybe<Scalars['ID']>;
  containIsOld?: Maybe<Scalars['Boolean']>;
  goodsType?: Maybe<GoodsType>;
};

export type GoodsPaginator = {
  data: Array<Goods>;
  paginatorInfo: PaginatorInfo;
};

export type MenuListInput = {
  menuId?: Maybe<Scalars['ID']>;
  menuName?: Maybe<Scalars['String']>;
  productId?: Maybe<Scalars['ID']>;
  startDate?: Maybe<Scalars['Date']>;
  endDate?: Maybe<Scalars['Date']>;
};

export type MenuPaginator = {
  data: Array<MenuSchedule>;
  paginatorInfo: PaginatorInfo;
};

export type MenuSchedule = {
  menuId: Scalars['ID'];
  menuName: Scalars['String'];
  scheduleId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  productName: Scalars['String'];
};

/** 社食EC商品 */
export type FfbMasterProduct = {
  productId: Scalars['ID'];
  productName: Scalars['String'];
};

export type AdminGoodsSpecsInput = {
  goodsSeriesId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type GoodsSepecPaginator = {
  data: Array<GoodsSpec>;
  paginatorInfo: PaginatorInfo;
};

export type GoodsSeriesPaginator = {
  data: Array<GoodsSeries>;
  paginatorInfo: PaginatorInfo;
};

export type AdminDiscountsInput = {
  name?: Maybe<Scalars['String']>;
  applyDate?: Maybe<DateRange>;
  productId?: Maybe<Scalars['ID']>;
  partnerId?: Maybe<Scalars['ID']>;
};

export type DiscountPaginator = {
  data: Array<Discount>;
  paginatorInfo: PaginatorInfo;
};

export type AdminDiscountCodesInput = {
  discountId: Scalars['ID'];
};

export type DiscountCodePaginator = {
  data: Array<DiscountCode>;
  paginatorInfo: PaginatorInfo;
};

export type DiscountCode = {
  discountCodeId: Scalars['ID'];
  discountId: Scalars['ID'];
  code: Scalars['String'];
  availableCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
  isAvailable: Scalars['Boolean'];
};

export type OrderLimitsInput = {
  shippingDate?: Maybe<DateRange>;
  orderBy?: Maybe<Array<OrderByClause>>;
};

/** Allows ordering a list of records. */
export type OrderByClause = {
  /** The column that is used for ordering. */
  column: Scalars['String'];
  /** The direction that is used for ordering. */
  order: SortOrder;
};

/** Directions for ordering a list of records. */
export enum SortOrder {
  /** Sort records in ascending order. */
  Asc = 'ASC',
  /** Sort records in descending order. */
  Desc = 'DESC'
}

export type OrderLimit = {
  orderLimitId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  fulfillmentProcessId: Scalars['ID'];
  capacity: Scalars['Int'];
  remainingQuantity: Scalars['Int'];
};

export type SearchOrderLimitsInput = {
  shippingDate?: Maybe<DateRange>;
  remainingQuantityOperator?: Maybe<RemainingQuantityOperator>;
};

export type RemainingQuantityOperator = {
  quantity?: Maybe<Scalars['Int']>;
  operator: Operator;
};

export enum Operator {
  Equal = 'EQUAL',
  Greater = 'GREATER',
  Less = 'LESS',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type OrderLimitPaginator = {
  data: Array<OrderLimit>;
  paginatorInfo: PaginatorInfo;
};

export type ManufactureDatePaginator = {
  data: Array<ManufactureDate>;
  paginatorInfo: PaginatorInfo;
};

export type ManufactureDate = {
  orderLimitId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  manufactureMenuCsvUrl: Scalars['String'];
};

export type AdminOrderFulfillmentInput = {
  shippingDate?: Maybe<DateRange>;
};

export type GoodsSchedule = {
  goodsScheduleId: Scalars['ID'];
  goodsSpecId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  menuSets: Array<MenuSet>;
  goodsSpec: GoodsSpec;
  fulfillmentProcess: OrderFulfillmentProcess;
};

export type AdminGoodsSchedulesInput = {
  goodsSpecId?: Maybe<Scalars['ID']>;
  shippingCode?: Maybe<Scalars['String']>;
};

export type GoodsSchedulePaginator = {
  data: Array<GoodsSchedule>;
  paginatorInfo: PaginatorInfo;
};

export type AdminSalesListInput = {
  termStartRange?: Maybe<DateRange>;
  clientType?: Maybe<ClientType>;
};

export enum ClientType {
  Ffh = 'FFH',
  Ffm = 'FFM',
  My = 'MY'
}

export type SalesPaginator = {
  data: Array<Sales>;
  paginatorInfo: PaginatorInfo;
};

export type Sales = {
  salesId: Scalars['ID'];
  termStart: Scalars['Date'];
  termEnd: Scalars['Date'];
  clientType: ClientType;
  paymentMethod: PaymentMethod;
  gross: Scalars['Int'];
  previousAdvanceReceived: Scalars['Int'];
  advanceReceived: Scalars['Int'];
  cancelAmount: Scalars['Int'];
  refundAmount: Scalars['Int'];
  scheduledTransfer: Scalars['Int'];
  items: Array<SalesItem>;
};

export type SalesItem = {
  salesItemId: Scalars['ID'];
  salesId: Scalars['ID'];
  gross: Scalars['Int'];
  tax: Scalars['Int'];
};

export type AdminSalesInput = {
  termStart: Scalars['Date'];
  clientType: ClientType;
};

export type AdminServiceProductsInput = {
  servicePlanId: Scalars['ID'];
  baseDate?: Maybe<Scalars['Date']>;
};

export type ShippingNumber = {
  shippingNumberId: Scalars['ID'];
  orderItemId: Scalars['ID'];
  shippingNumber: Scalars['String'];
};

export type AdminShippingSummariesInput = {
  shippingDate?: Maybe<DateRange>;
};

export type ShippingSummaryOldPaginator = {
  data: Array<ShippingSummaryOld>;
  paginatorInfo: PaginatorInfo;
};

export type ShippingSummaryOld = {
  shippingDate: Scalars['Date'];
  totalQuantity: Scalars['Int'];
  productSummaries: Array<ShippingProductSummaryOld>;
  invoiceExcelUrl: Scalars['String'];
  shippingProductPdf: Scalars['String'];
  shippingProductCsv: Scalars['String'];
  fixDeliveryDate?: Maybe<Scalars['Date']>;
  canDelivery?: Maybe<Scalars['Boolean']>;
};

export type ShippingProductSummaryOld = {
  productId: Scalars['String'];
  productCode: Scalars['String'];
  productModelNumber: Scalars['String'];
  productName: Scalars['String'];
  totalQuantity: Scalars['Int'];
  goodsSeries?: Maybe<GoodsSeries>;
  product?: Maybe<Product>;
};

export type AdminShippingsInput = {
  partnerName?: Maybe<Scalars['String']>;
  partnerCode?: Maybe<Scalars['String']>;
  shippingDate?: Maybe<DateRange>;
  deliveryDate?: Maybe<DateRange>;
  trackingNumber?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Array<OrderByClause>>;
};

export type ShippingOldPaginator = {
  data: Array<ShippingOld>;
  paginatorInfo: PaginatorInfo;
};

export type ShippingOld = {
  shippingId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  orderId: Scalars['String'];
  productId: Scalars['String'];
  productCode: Scalars['String'];
  productModelNumber: Scalars['String'];
  productName: Scalars['String'];
  quantity: Scalars['Int'];
  shippingAddress: Address;
  recipientPhone: Scalars['String'];
  shippingCompanyDepartment?: Maybe<Scalars['String']>;
  destinationName: Scalars['String'];
  deliveryTime: DeliveryTime;
  shippingStatus: ShippingStatusOld;
  trackingNumbers: Array<Scalars['String']>;
};

export type ShippingStatusOld = {
  code: Scalars['Int'];
  label: Scalars['String'];
};

export type NearestShippingDateInput = {
  orderDate?: Maybe<Scalars['Date']>;
  includeStock?: Maybe<Scalars['Boolean']>;
};

export type AdminShippingItemsInput = {
  shippingDate?: Maybe<DateRange>;
  deliveryDate?: Maybe<DateRange>;
  trackingNumber?: Maybe<Scalars['String']>;
  orderNo?: Maybe<Scalars['String']>;
  orderBy?: Maybe<Array<OrderByClause>>;
};

export type ShippingItemPaginator = {
  data: Array<ShippingItem>;
  paginatorInfo: PaginatorInfo;
};

export type ShippingItem = {
  shippingItemId: Scalars['ID'];
  shippingId: Scalars['ID'];
  clientOrderUserId?: Maybe<Scalars['String']>;
  clientOrderId: Scalars['String'];
  clientOrderItemId: Scalars['String'];
  clientOrderNo?: Maybe<Scalars['String']>;
  stockType: StockType;
  stockId?: Maybe<Scalars['ID']>;
  warehouseId?: Maybe<Scalars['ID']>;
  masterProductId?: Maybe<Scalars['ID']>;
  fulfillmentProcessId?: Maybe<Scalars['ID']>;
  shippingCode?: Maybe<Scalars['String']>;
  clientProductId: Scalars['String'];
  clientProductCode: Scalars['String'];
  clientProductName: Scalars['String'];
  clientProductLotNo: Scalars['String'];
  quantity: Scalars['Int'];
  shipping?: Maybe<Shipping>;
};

export enum StockType {
  NonStock = 'NonStock',
  UseStock = 'UseStock'
}

export type Shipping = {
  shippingId: Scalars['ID'];
  clientShippingId: Scalars['String'];
  clientType: ClientType;
  shippingStatus: ShippingStatus;
  trackingNumbers: Array<Scalars['String']>;
  shippingDate: Scalars['Date'];
  deliveryTime: DeliveryTime;
  deliveryAddress: Address;
  recipientName: Scalars['String'];
  recipientPhone: Scalars['String'];
  recipientEmail?: Maybe<Scalars['String']>;
  recipientCompanyDepartment?: Maybe<Scalars['String']>;
  senderAddress: Address;
  senderName: Scalars['String'];
  senderKanaName?: Maybe<Scalars['String']>;
  senderPhone?: Maybe<Scalars['String']>;
  shippingItems: Array<ShippingItem>;
};

export enum ShippingStatus {
  ReadyToShip = 'ReadyToShip',
  Shipped = 'Shipped'
}

export type ShippingSummaryPaginator = {
  data: Array<ShippingSummary>;
  paginatorInfo: PaginatorInfo;
};

export type ShippingSummary = {
  shippingDate: Scalars['Date'];
  totalQuantity: Scalars['Int'];
  productSummaries: Array<ShippingProductSummary>;
  invoiceExcelUrl: Scalars['String'];
  shippingProductPdf: Scalars['String'];
  shippingProductCsv: Scalars['String'];
  fixDeliveryDate?: Maybe<Scalars['Date']>;
  canDelivery?: Maybe<Scalars['Boolean']>;
};

export type ShippingProductSummary = {
  clientProductId: Scalars['String'];
  clientType: ClientType;
  clientProductLotNo: Scalars['String'];
  clientProductName: Scalars['String'];
  totalQuantity: Scalars['Int'];
  goodsSeries?: Maybe<GoodsSeries>;
  product?: Maybe<Product>;
};

export type AdminStocksInput = {
  fulfillmentProcessId?: Maybe<Scalars['ID']>;
  masterProductId?: Maybe<Scalars['ID']>;
};

export type StockPaginator = {
  data: Array<Stock>;
  paginatorInfo: PaginatorInfo;
};

export type AdminStockLogsInput = {
  stockId: Scalars['ID'];
};

export type StockLogPaginator = {
  data: Array<StockLog>;
  paginatorInfo: PaginatorInfo;
};

export type AdminMasterProductsInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
};

export type MasterProductPaginator = {
  data: Array<MasterProduct>;
  paginatorInfo: PaginatorInfo;
};

export type Batch = {
  id: Scalars['ID'];
  code: Scalars['String'];
  name: Scalars['String'];
  status: BatchStatus;
  args?: Maybe<Scalars['String']>;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  canceledAt?: Maybe<Scalars['DateTime']>;
  executionTime?: Maybe<Scalars['Float']>;
  schedule: BatchSchedule;
  jobs: Array<BatchJob>;
};

export type BatchStatus = {
  code: BatchStatusCode;
  label: Scalars['String'];
};

export enum BatchStatusCode {
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED',
  Canceled = 'CANCELED'
}

export type BatchSchedule = {
  frequency: Scalars['String'];
  week?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
};

export type BatchJob = {
  id: Scalars['ID'];
  batchId: Scalars['String'];
  code: Scalars['String'];
  status: JobStatus;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  successCount: Scalars['Int'];
  executionTime?: Maybe<Scalars['Float']>;
  steps: Array<BatchJobStep>;
};

export type JobStatus = {
  code: JobStatusCode;
  label: Scalars['String'];
};

export enum JobStatusCode {
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED'
}

export type BatchJobStep = {
  id: Scalars['ID'];
  jobId: Scalars['String'];
  mode: ExecutionMode;
  status: JobStepStatus;
  startedAt: Scalars['DateTime'];
  finishedAt?: Maybe<Scalars['DateTime']>;
  successCount: Scalars['Int'];
  failureCount: Scalars['Int'];
};

export type ExecutionMode = {
  code: ExecutionModeCode;
  label: Scalars['String'];
};

export enum ExecutionModeCode {
  Normal = 'NORMAL',
  Rerun = 'RERUN'
}

export type JobStepStatus = {
  code: JobStepStatusCode;
  label: Scalars['String'];
};

export enum JobStepStatusCode {
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED',
  Failed = 'FAILED'
}

export type AdminBatchesInput = {
  startedAt?: Maybe<DateRange>;
  batchCode?: Maybe<Scalars['String']>;
  batchName?: Maybe<Scalars['String']>;
};

export type BatchPaginator = {
  data: Array<Batch>;
  paginatorInfo: PaginatorInfo;
};

export type Versions = {
  ffm: Version;
  front: Version;
  adminFront: Version;
};

export type Version = {
  version?: Maybe<Scalars['String']>;
  revision?: Maybe<Scalars['String']>;
  releaseDate?: Maybe<Scalars['Date']>;
};

export type AdminTransferInput = {
  termStart: Scalars['Date'];
  clientType: ClientType;
};

export type Transfer = {
  clientType: ClientType;
  termStart: Scalars['Date'];
  termEnd: Scalars['Date'];
  scheduled: Scalars['Int'];
  actual: PayjpTransferItem;
  difference: Scalars['Int'];
};

export type PayjpTransferItem = {
  payjpTransferItemId: Scalars['ID'];
  payjpTransferId: Scalars['ID'];
  clientType: ClientType;
  amount: Scalars['Int'];
  chargeCount: Scalars['Int'];
  chargeFee: Scalars['Int'];
  chargeGross: Scalars['Int'];
  net: Scalars['Int'];
  refundAmount: Scalars['Int'];
  refundCount: Scalars['Int'];
  disputeAmount: Scalars['Int'];
  disputeCount: Scalars['Int'];
  payjpTransactionId: Scalars['String'];
};

export type ShippingAddress = {
  shippingAddressId: Scalars['ID'];
  userId: Scalars['String'];
  name: Scalars['String'];
  destinationName: Scalars['String'];
  address: Address;
  phone?: Maybe<Scalars['String']>;
  companyDepartment?: Maybe<Scalars['String']>;
  main: Scalars['Boolean'];
};

export type AdminUserSearchInput = {
  userId?: Maybe<Scalars['ID']>;
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameKana?: Maybe<Scalars['String']>;
};

export type UserPaginator = {
  data: Array<User>;
  paginatorInfo: PaginatorInfo;
};

export type CreditCard = {
  cardId: Scalars['ID'];
  expYear: Scalars['String'];
  expMonth: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  last4: Scalars['String'];
  isMain: Scalars['Boolean'];
};

export type AffiliateInput = {
  storeId: Scalars['ID'];
  range?: Maybe<DateRange>;
};

export type Affiliate = {
  code: Scalars['String'];
  name: Scalars['String'];
  bonus: BonusSet;
  bonusIncludeTax: BonusSet;
  customerCount: QuantitySet;
  boughtCount: QuantitySet;
  ffhProductTypes: Array<FfhProductType>;
  invitationLink: Scalars['String'];
  invitationQrcodeLink: Scalars['String'];
};

export type BonusSet = {
  cumulative: Scalars['Int'];
  limited: Scalars['Int'];
};

export type QuantitySet = {
  cumulative: Scalars['Int'];
  limited: Scalars['Int'];
};

export type FfhProductType = {
  name: Scalars['String'];
  label: Scalars['String'];
  normalQuantity: QuantitySet;
  normalBonus: BonusSet;
  periodicQuantity: QuantitySet;
  periodicBonus: BonusSet;
  totalBonus: BonusSet;
};

export type TotalAffiliateInput = {
  partnerId: Scalars['ID'];
  range?: Maybe<DateRange>;
};

export type TotalAffiliate = {
  bonus: BonusSet;
  bonusIncludeTax: BonusSet;
  customerCount: QuantitySet;
  boughtCount: QuantitySet;
  ffhProductTypes: Array<FfhProductType>;
};

export type Authorization = {
  feature: Feature;
  allowed: Scalars['Boolean'];
};

export enum Feature {
  Affiliate = 'Affiliate',
  BankAccount = 'BankAccount'
}

export type CartInput = {
  date?: Maybe<Scalars['Date']>;
  items: Array<CartItemInput>;
  discountCode?: Maybe<Scalars['String']>;
};

export type CartItemInput = {
  productId: Scalars['String'];
  quantity: Scalars['Int'];
};

export type AgentSalesCartInput = {
  deliveryFrequency: DeliveryFrequency;
  numberOfDeliveries: Scalars['Int'];
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: Scalars['Int'];
  productQuantities: Array<CartItemInput>;
  consumerPartnerId: Scalars['ID'];
  discountCode?: Maybe<Scalars['String']>;
};

export type AgentSalesCart = {
  productQuantities: Array<ProductQuantity>;
  price: Price;
  schedules: Array<AgentSalesCartSchedule>;
};

export type ProductQuantity = {
  product: Product;
  quantity: Scalars['Int'];
};

export type AgentSalesCartSchedule = {
  deliveryTime: DeliveryTime;
  fixDate: Scalars['Date'];
  price: Price;
  items: Array<AgentSalesCartItem>;
};

export type AgentSalesCartItem = {
  product: Product;
  quantity: Scalars['Int'];
  price: Price;
};

export type StoreSalesOrdersInput = {
  storeId?: Maybe<Scalars['ID']>;
};

export type StoreSalesOrderPaginator = {
  data: Array<Order>;
  paginatorInfo: PaginatorInfo;
};

export type AgentSalesOrdersInput = {
  status?: Maybe<AgentSalesOrderStatus>;
  orderNo?: Maybe<Scalars['String']>;
  storeId?: Maybe<Scalars['ID']>;
};

export type SubscriptionInput = {
  storeId?: Maybe<Scalars['ID']>;
};

export type StoresInput = {
  partnerId: Scalars['ID'];
};

export type StoreShippingAddressPaginator = {
  data: Array<StoreShippingAddress>;
  paginatorInfo: PaginatorInfo;
};

export type StoreOwnersInput = {
  partnerId: Scalars['ID'];
};

export type StoreOwnerInput = {
  partnerId: Scalars['ID'];
  userId: Scalars['ID'];
};

export type SalesProductsInput = {
  partnerServiceContractId: Scalars['ID'];
  baseDate?: Maybe<Scalars['Date']>;
};

export type SalesProduct = {
  type: ServicePlanType;
  product: Product;
  available: Scalars['Boolean'];
  availableQuantity: Scalars['Int'];
};

export type ProgramDeliveryScheduleInput = {
  options: ProgramDeliveryOptionsInput;
};

export type ProgramDeliveryOptionsInput = {
  deliveryFrequency: DeliveryFrequency;
  numberOfDeliveries: Scalars['Int'];
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: Scalars['Int'];
};

export type ProgramDeliverySchedule = {
  deliveryTimes?: Maybe<Array<DeliveryTime>>;
};

export type ShippingRegion = {
  shippingRegionId: Scalars['ID'];
  zipCode: ZipCode;
  pref: Pref;
  locality: Scalars['String'];
  regionCode: RegionCode;
};

export enum RegionCode {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E'
}

/** 利用可能な配送回数。局所的な型なのでここで定義する。 */
export type AvailableDeliveryCount = {
  deliveryFrequency: DeliveryFrequency;
  count: Scalars['Int'];
};

export type CreditCardToken = {
  cardId: Scalars['ID'];
  userId: Scalars['ID'];
  paymentTokenId: Scalars['String'];
};

export type AgentSalesDestinationPaginator = {
  data: Array<AgentSalesDestination>;
  paginatorInfo: PaginatorInfo;
};

export type AgentSalesDestination = {
  agentSalesDestinationId: Scalars['ID'];
  partnerId: Scalars['ID'];
  storeId: Scalars['ID'];
  name: PersonName;
  nameKana: PersonName;
  address: Address;
  phone: Scalars['String'];
  email: Scalars['String'];
  discountCode?: Maybe<Scalars['String']>;
  code?: Maybe<DiscountCode>;
  store?: Maybe<Store>;
};

export type Mutation = {
  reportError?: Maybe<Scalars['Boolean']>;
  adminLogin?: Maybe<Admin>;
  adminLogout?: Maybe<Scalars['Boolean']>;
  adminCreateAdmin: Admin;
  adminUpdateAdmin: Admin;
  adminRejectPartnerApplication: PartnerApplication;
  adminUnderReviewPartnerApplication: PartnerApplication;
  adminApprovePartnerApplication: PartnerApplication;
  adminVerifyBilling: Billing;
  adminSendBilling: Scalars['Boolean'];
  adminBatchReCreateBillingForm?: Maybe<Scalars['Boolean']>;
  adminCreatePartnerContract: PartnerContract;
  adminUpdatePartnerContract: PartnerContract;
  adminReFixAgentSalesOrder: AgentSalesOrder;
  adminCancelAgentSalesShippingItems: AgentSalesOrder;
  adminRefundOrder: Refund;
  adminCreateSubscription: SubscriptionBase;
  adminContractSubscription: SubscriptionBase;
  adminFinishSubscription: SubscriptionBase;
  adminFixSubscription: Array<SubscriptionBase>;
  adminCancelOrder: Order;
  adminImportNpResultCsv: ImportNpResultResponse;
  adminCreateOrder: Order;
  adminCreatePartner: Partner;
  adminUpdatePartner: Partner;
  adminCreateStores: Array<Store>;
  adminUpdateStores: Array<Store>;
  adminUpdateMembers: Array<Member>;
  adminCreateIndustry: Industry;
  adminUpdateIndustry: Industry;
  createFfGoods: Goods;
  updateFfGoods: Goods;
  adminDeleteFfGoods: Goods;
  adminCreateGoodsSeries: GoodsSeries;
  adminCreateGoodsSpec: GoodsSpec;
  adminUpdateGoodsSpec: GoodsSpec;
  adminCreateDiscount: Discount;
  adminUpdateDiscount: Discount;
  adminDeleteDiscount: Discount;
  adminCreateDiscountCode: DiscountCode;
  adminCreateDiscountCodes: Array<DiscountCode>;
  adminUpdateDiscountCode: DiscountCode;
  adminDeleteDiscountCode: DiscountCode;
  adminCreateMasterProduct: MasterProduct;
  createOrderLimit: OrderLimit;
  updateOrderLimit: OrderLimit;
  adminCreateOrderFulfillment: OrderFulfillmentProcess;
  adminCreateGoodsSchedule: GoodsSchedule;
  adminUpdateGoodsSchedule: GoodsSchedule;
  /** @deprecated FFX出荷のリリース後、正式運用を経たのち削除。 TODO: DELETE OLD FFX */
  adminImportShippingCsvOld: ImportShippingCsv;
  adminImportShippingCsv: ImportShippingCsv;
  adminCreateFutureStock: Stock;
  adminStoreStock: Stock;
  adminChangeStock: Stock;
  adminRerunBatch: Scalars['Boolean'];
  adminCancelBatch: Scalars['Boolean'];
  contact?: Maybe<Contact>;
  orderFfGoods: Order;
  cancelFfGoodsOrder: Order;
  updateDeliveryTime: Order;
  createAgentSalesOrder: AgentSalesOrder;
  updateAgentSalesOrder: AgentSalesOrder;
  cancelAgentSalesShippingItem: AgentSalesOrder;
  createStoreOwner: Member;
  createStoreShippingAddress: StoreShippingAddress;
  updateStoreShippingAddress: StoreShippingAddress;
  changeMainStoreShippingAddress: StoreShippingAddress;
  deleteStoreShippingAddress: StoreShippingAddress;
  createPartnerBankAccount: PartnerBankAccount;
  updatePartnerBankAccount: PartnerBankAccount;
  deletePartnerBankAccount: PartnerBankAccount;
  createPartnerApplication: PartnerApplication;
  register?: Maybe<AuthPayload>;
  login?: Maybe<AuthPayload>;
  logout: Scalars['Boolean'];
  forgotPassword?: Maybe<Scalars['Boolean']>;
  resetPassword?: Maybe<Scalars['Boolean']>;
  updatePassword?: Maybe<Scalars['Boolean']>;
  resendVerificationEmail?: Maybe<Scalars['Boolean']>;
  updateProfile?: Maybe<User>;
  createCreditCard: CreditCard;
  deleteCreditCard: Scalars['ID'];
  createShippingAddress: ShippingAddress;
  updateShippingAddress: ShippingAddress;
  changeMainShippingAddress: ShippingAddress;
  deleteShippingAddress: ShippingAddress;
  createAgentSalesDestination: AgentSalesDestination;
  updateAgentSalesDestination: AgentSalesDestination;
  deleteAgentSalesDestination: AgentSalesDestination;
};


export type MutationReportErrorArgs = {
  error: Error;
};


export type MutationAdminLoginArgs = {
  input: AdminLoginInput;
};


export type MutationAdminCreateAdminArgs = {
  input: AdminCreateAdminInput;
};


export type MutationAdminUpdateAdminArgs = {
  input: AdminUpdateAdminInput;
};


export type MutationAdminRejectPartnerApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationAdminUnderReviewPartnerApplicationArgs = {
  id: Scalars['ID'];
};


export type MutationAdminApprovePartnerApplicationArgs = {
  input: AdminApprovePartnerApplicationInput;
};


export type MutationAdminVerifyBillingArgs = {
  id: Scalars['ID'];
};


export type MutationAdminSendBillingArgs = {
  yearMonth: Scalars['YearMonth'];
};


export type MutationAdminBatchReCreateBillingFormArgs = {
  yearMonth: Scalars['YearMonth'];
};


export type MutationAdminCreatePartnerContractArgs = {
  input: AdminCreatePartnerContractInput;
};


export type MutationAdminUpdatePartnerContractArgs = {
  input: AdminUpdatePartnerContractInput;
};


export type MutationAdminReFixAgentSalesOrderArgs = {
  input: AdminReFixAgentSalesOrderInput;
};


export type MutationAdminCancelAgentSalesShippingItemsArgs = {
  input: AdminCancelAgentSalesShippingItemsInput;
};


export type MutationAdminRefundOrderArgs = {
  input: RefundOrderInput;
};


export type MutationAdminCreateSubscriptionArgs = {
  input: AdminCreateSubscriptionInput;
};


export type MutationAdminContractSubscriptionArgs = {
  subscriptionId: Scalars['ID'];
};


export type MutationAdminFinishSubscriptionArgs = {
  subscriptionId: Scalars['ID'];
};


export type MutationAdminCancelOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationAdminImportNpResultCsvArgs = {
  input: AdminImportNpResultCsvInput;
};


export type MutationAdminCreateOrderArgs = {
  input: AdminCreateOrderInput;
};


export type MutationAdminCreatePartnerArgs = {
  input: AdminCreatePartnerInput;
};


export type MutationAdminUpdatePartnerArgs = {
  input: AdminUpdatePartnerInput;
};


export type MutationAdminCreateStoresArgs = {
  input: AdminCreateStoresInput;
};


export type MutationAdminUpdateStoresArgs = {
  input: AdminUpdateStoresInput;
};


export type MutationAdminUpdateMembersArgs = {
  input: AdminUpdateMembersInput;
};


export type MutationAdminCreateIndustryArgs = {
  input: AdminCreateIndustryInput;
};


export type MutationAdminUpdateIndustryArgs = {
  input: AdminUpdateIndustryInput;
};


export type MutationCreateFfGoodsArgs = {
  input: CreateFfGoodsInput;
};


export type MutationUpdateFfGoodsArgs = {
  input: UpdateFfGoodsInput;
};


export type MutationAdminDeleteFfGoodsArgs = {
  id: Scalars['ID'];
};


export type MutationAdminCreateGoodsSeriesArgs = {
  input: AdminCreateGoodsSeriesInput;
};


export type MutationAdminCreateGoodsSpecArgs = {
  input: AdminCreateGoodsSpecInput;
};


export type MutationAdminUpdateGoodsSpecArgs = {
  input: AdminUpdateGoodsSpecInput;
};


export type MutationAdminCreateDiscountArgs = {
  input: AdminCreateDiscountInput;
};


export type MutationAdminUpdateDiscountArgs = {
  input: AdminUpdateDiscountInput;
};


export type MutationAdminDeleteDiscountArgs = {
  id: Scalars['ID'];
};


export type MutationAdminCreateDiscountCodeArgs = {
  input: AdminCreateDiscountCodeInput;
};


export type MutationAdminCreateDiscountCodesArgs = {
  input: Array<AdminCreateDiscountCodeInput>;
};


export type MutationAdminUpdateDiscountCodeArgs = {
  input: AdminUpdateDiscountCodeInput;
};


export type MutationAdminDeleteDiscountCodeArgs = {
  id: Scalars['ID'];
};


export type MutationAdminCreateMasterProductArgs = {
  input: AdminCreateMasterProductInput;
};


export type MutationCreateOrderLimitArgs = {
  input: CreateOrderLimitInput;
};


export type MutationUpdateOrderLimitArgs = {
  input: UpdateOrderLimitInput;
};


export type MutationAdminCreateOrderFulfillmentArgs = {
  input: AdminCreateOrderFulfillmentInput;
};


export type MutationAdminCreateGoodsScheduleArgs = {
  input: AdminCreateGoodsScheduleInput;
};


export type MutationAdminUpdateGoodsScheduleArgs = {
  input: AdminUpdateGoodsScheduleInput;
};


export type MutationAdminImportShippingCsvOldArgs = {
  input: AdminImportShippingOldInput;
};


export type MutationAdminImportShippingCsvArgs = {
  input: AdminImportShippingInput;
};


export type MutationAdminCreateFutureStockArgs = {
  input: AdminCreateFutureStockInput;
};


export type MutationAdminStoreStockArgs = {
  input: AdminStoreStockInput;
};


export type MutationAdminChangeStockArgs = {
  input: AdminChangeStockInput;
};


export type MutationAdminRerunBatchArgs = {
  id: Scalars['ID'];
};


export type MutationAdminCancelBatchArgs = {
  id: Scalars['ID'];
};


export type MutationContactArgs = {
  input: ContactInput;
};


export type MutationOrderFfGoodsArgs = {
  input: OrderFfGoodsInput;
};


export type MutationCancelFfGoodsOrderArgs = {
  input: CancelFfGoodsOrderInput;
};


export type MutationUpdateDeliveryTimeArgs = {
  input: UpdateDeliveryTimeInput;
};


export type MutationCreateAgentSalesOrderArgs = {
  input: CreateAgentSalesOrderInput;
};


export type MutationUpdateAgentSalesOrderArgs = {
  input: UpdateAgentSalesOrderInput;
};


export type MutationCancelAgentSalesShippingItemArgs = {
  input: CancelAgentSalesShippingItemInput;
};


export type MutationCreateStoreOwnerArgs = {
  input: CreateStoreOwnerInput;
};


export type MutationCreateStoreShippingAddressArgs = {
  input: CreateStoreShippingAddressInput;
};


export type MutationUpdateStoreShippingAddressArgs = {
  input: UpdateStoreShippingAddressInput;
};


export type MutationChangeMainStoreShippingAddressArgs = {
  storeId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationDeleteStoreShippingAddressArgs = {
  storeId: Scalars['ID'];
  id: Scalars['ID'];
};


export type MutationCreatePartnerBankAccountArgs = {
  input: CreatePartnerBankAccountInput;
};


export type MutationUpdatePartnerBankAccountArgs = {
  input: UpdatePartnerBankAccountInput;
};


export type MutationDeletePartnerBankAccountArgs = {
  id: Scalars['ID'];
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
};


export type MutationCreatePartnerApplicationArgs = {
  input: CreatePartnerApplicationInput;
};


export type MutationRegisterArgs = {
  input: RegisterInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type MutationUpdateProfileArgs = {
  input: UpdateProfileInput;
};


export type MutationCreateCreditCardArgs = {
  paymentToken: Scalars['String'];
};


export type MutationDeleteCreditCardArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationCreateShippingAddressArgs = {
  input?: Maybe<CreateShippingAddressInput>;
};


export type MutationUpdateShippingAddressArgs = {
  input?: Maybe<UpdateShippingAddressInput>;
};


export type MutationChangeMainShippingAddressArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationDeleteShippingAddressArgs = {
  id?: Maybe<Scalars['ID']>;
};


export type MutationCreateAgentSalesDestinationArgs = {
  input: CreateAgentSalesDestinationInput;
};


export type MutationUpdateAgentSalesDestinationArgs = {
  input: UpdateAgentSalesDestinationInput;
};


export type MutationDeleteAgentSalesDestinationArgs = {
  id: Scalars['ID'];
};

export type Error = {
  name?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  stack?: Maybe<Scalars['String']>;
};

export type AdminLoginInput = {
  loginId: Scalars['String'];
  password: Scalars['String'];
};

export type AdminCreateAdminInput = {
  loginId: Scalars['String'];
  email: Scalars['String'];
  nameL: Scalars['String'];
  nameF: Scalars['String'];
  password: Scalars['String'];
};

export type AdminUpdateAdminInput = {
  loginId: Scalars['String'];
  email: Scalars['String'];
  nameL: Scalars['String'];
  nameF: Scalars['String'];
};

export type AdminApprovePartnerApplicationInput = {
  partnerApplicationId: Scalars['ID'];
  partnerCode: Scalars['String'];
  isRoyal: Scalars['Boolean'];
  parentPartnerId?: Maybe<Scalars['ID']>;
  paymentMethod: PaymentMethod;
  bankTransferType: BankTransferType;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  storeApplicationInputs: Array<AdminApproveStoreApplicationInput>;
};

export type AdminApproveStoreApplicationInput = {
  storeApplicationId: Scalars['ID'];
  storeCode: Scalars['String'];
  affiliateId?: Maybe<Scalars['Int']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type AdminCreatePartnerContractInput = {
  partnerId: Scalars['ID'];
  useAffiliate: Scalars['Boolean'];
  startedAt: Scalars['Date'];
  finishedAt?: Maybe<Scalars['Date']>;
  serviceContracts?: Maybe<Array<AdminCreatePartnerServiceContractInput>>;
};

export type AdminCreatePartnerServiceContractInput = {
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  productContracts?: Maybe<Array<AdminCreateProductContractInput>>;
};

export type AdminCreateProductContractInput = {
  serviceProductId: Scalars['ID'];
};

export type AdminUpdatePartnerContractInput = {
  partnerContractId: Scalars['ID'];
  partnerId: Scalars['ID'];
  useAffiliate: Scalars['Boolean'];
  startedAt: Scalars['Date'];
  finishedAt?: Maybe<Scalars['Date']>;
  serviceContracts?: Maybe<Array<AdminUpdatePartnerServiceContractInput>>;
};

export type AdminUpdatePartnerServiceContractInput = {
  partnerServiceContractId?: Maybe<Scalars['ID']>;
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  productContracts?: Maybe<Array<AdminUpdateProductContractInput>>;
};

export type AdminUpdateProductContractInput = {
  serviceProductId: Scalars['ID'];
};

export type AdminReFixAgentSalesOrderInput = {
  agentSalesOrderId: Scalars['ID'];
  agentSalesShippingItemIds: Array<Scalars['ID']>;
};

export type AdminCancelAgentSalesShippingItemsInput = {
  agentSalesOrderId: Scalars['ID'];
  agentSalesShippingItemIds: Array<Scalars['ID']>;
};

export type RefundOrderInput = {
  orderId: Scalars['ID'];
  amount: Scalars['Int'];
  reason?: Maybe<Scalars['String']>;
};

export type AdminCreateSubscriptionInput = {
  consumerPartnerId: Scalars['ID'];
  consumerStoreId: Scalars['ID'];
  consumerUserId: Scalars['ID'];
  applicationDate: Scalars['Date'];
  recipientZipCode: Scalars['String'];
  recipientPrefId: Scalars['ID'];
  recipientAddress1: Scalars['String'];
  recipientAddress2?: Maybe<Scalars['String']>;
  recipientNameF: Scalars['String'];
  recipientNameL: Scalars['String'];
  recipientKanaF: Scalars['String'];
  recipientKanaL: Scalars['String'];
  recipientPhoneNumber: Scalars['String'];
  recipientEmail?: Maybe<Scalars['String']>;
  deliveryFrequency: DeliveryFrequency;
  numberOfDelivery?: Maybe<Scalars['Int']>;
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: Scalars['Int'];
  subscriptionItems: Array<AdminCreateSubscriptionItemInput>;
  salesChannel: SalesChannel;
};

export type AdminCreateSubscriptionItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AdminImportNpResultCsvInput = {
  shippingDate: Scalars['Date'];
  csvFile: Scalars['Upload'];
};


export type ImportNpResultResponse = {
  isSuccess: Scalars['Boolean'];
  failedCount: Scalars['Int'];
  failedRows: Array<FailedRow>;
};

export type FailedRow = {
  row: Scalars['Int'];
  reason: Scalars['String'];
};

export type AdminCreateOrderInput = {
  salesChannel: SalesChannel;
  consumerPartnerId: Scalars['ID'];
  consumerStoreId: Scalars['ID'];
  consumerUserId: Scalars['ID'];
  recipientZipCode: Scalars['String'];
  recipientPrefId: Scalars['ID'];
  recipientAddress1: Scalars['String'];
  recipientAddress2?: Maybe<Scalars['String']>;
  recipientNameF: Scalars['String'];
  recipientNameL: Scalars['String'];
  recipientPhoneNumber: Scalars['String'];
  recipientEmail?: Maybe<Scalars['String']>;
  deliveryDate: Scalars['Date'];
  deliveryTimeSlot: Scalars['Int'];
  orderItems: Array<AdminCreateOrderItemInput>;
};

export type AdminCreateOrderItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AdminCreatePartnerInput = {
  companyName: Scalars['String'];
  name: Scalars['String'];
  partnerCode: Scalars['String'];
  partnerLogoFile?: Maybe<Scalars['Upload']>;
  paymentMethod: PaymentMethod;
  bankTransferType: BankTransferType;
  isRoyal: Scalars['Boolean'];
  ownerName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['ID'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  siteUrl: Scalars['String'];
};

export type AdminUpdatePartnerInput = {
  partnerId: Scalars['ID'];
  companyName: Scalars['String'];
  name: Scalars['String'];
  partnerCode: Scalars['String'];
  partnerLogoFile?: Maybe<Scalars['Upload']>;
  paymentMethod: PaymentMethod;
  bankTransferType: BankTransferType;
  isRoyal: Scalars['Boolean'];
  ownerName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['ID'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  siteUrl: Scalars['String'];
};

export type AdminCreateStoresInput = {
  partnerId: Scalars['ID'];
  stores: Array<AdminStoreInput>;
};

export type AdminStoreInput = {
  storeId?: Maybe<Scalars['ID']>;
  name: Scalars['String'];
  storeCode: Scalars['String'];
  affiliateId?: Maybe<Scalars['Int']>;
  prefId: Scalars['ID'];
  zipCode: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  industryId: Scalars['ID'];
};

export type AdminUpdateStoresInput = {
  partnerId: Scalars['ID'];
  stores: Array<AdminStoreInput>;
};

export type AdminUpdateMembersInput = {
  partnerId: Scalars['ID'];
  members: Array<Maybe<AdminMemberInput>>;
};

export type AdminMemberInput = {
  memberId?: Maybe<Scalars['ID']>;
  partnerId: Scalars['ID'];
  userId: Scalars['ID'];
  type: MemberType;
  externalId?: Maybe<Scalars['String']>;
};

export type AdminCreateIndustryInput = {
  name: Scalars['String'];
  isVisible: Scalars['Boolean'];
  pos: Scalars['Int'];
};

export type AdminUpdateIndustryInput = {
  industryId: Scalars['ID'];
  name: Scalars['String'];
  isVisible: Scalars['Boolean'];
  pos: Scalars['Int'];
};

export type CreateFfGoodsInput = {
  goodsSpecId: Scalars['ID'];
  price: Scalars['Int'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  setQuantity: Scalars['Int'];
  manufactureUnit: Scalars['Int'];
  mainImageFile?: Maybe<Scalars['Upload']>;
  goodsType: GoodsType;
  masterProductId?: Maybe<Scalars['String']>;
};

export type UpdateFfGoodsInput = {
  goodsSpecId: Scalars['ID'];
  productId: Scalars['String'];
  price: Scalars['Int'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  mainImage?: Maybe<Scalars['String']>;
  published: Scalars['Boolean'];
  setQuantity: Scalars['Int'];
  manufactureUnit?: Maybe<Scalars['Int']>;
  mainImageFile?: Maybe<Scalars['Upload']>;
  goodsType: GoodsType;
  masterProductId?: Maybe<Scalars['String']>;
};

export type AdminCreateGoodsSeriesInput = {
  name: Scalars['String'];
};

export type AdminCreateGoodsSpecInput = {
  goodsSeriesId: Scalars['ID'];
  name: Scalars['String'];
};

export type AdminUpdateGoodsSpecInput = {
  goodsSpecId: Scalars['ID'];
  goodsSeriesId: Scalars['ID'];
  name: Scalars['String'];
};

export type AdminCreateDiscountInput = {
  type: DiscountType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  discountRate?: Maybe<Scalars['Float']>;
  isExclusive: Scalars['Boolean'];
  isCodeRequired: Scalars['Boolean'];
  actionKey?: Maybe<DiscountTriggerAction>;
  constraints: Array<AdminCreateDiscountConstraintInput>;
};

export type AdminCreateDiscountConstraintInput = {
  type: DiscountConstraintType;
  productIds?: Maybe<Array<Scalars['ID']>>;
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  maxUseCount?: Maybe<Scalars['Int']>;
  maxItemQuantity?: Maybe<Scalars['Int']>;
  maxDiscountRate?: Maybe<Scalars['Float']>;
};

export type AdminUpdateDiscountInput = {
  discountId: Scalars['ID'];
  type: DiscountType;
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  discountRate?: Maybe<Scalars['Float']>;
  isExclusive: Scalars['Boolean'];
  isCodeRequired: Scalars['Boolean'];
  actionKey?: Maybe<DiscountTriggerAction>;
  constraints: Array<AdminUpdateDiscountConstraintInput>;
};

export type AdminUpdateDiscountConstraintInput = {
  type: DiscountConstraintType;
  productIds?: Maybe<Array<Scalars['ID']>>;
  partnerIds?: Maybe<Array<Scalars['ID']>>;
  maxUseCount?: Maybe<Scalars['Int']>;
  maxItemQuantity?: Maybe<Scalars['Int']>;
  maxDiscountRate?: Maybe<Scalars['Float']>;
};

export type AdminCreateDiscountCodeInput = {
  discountId: Scalars['ID'];
  code: Scalars['String'];
  availableCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
};

export type AdminUpdateDiscountCodeInput = {
  discountCodeId: Scalars['ID'];
  discountId: Scalars['ID'];
  code: Scalars['String'];
  availableCount?: Maybe<Scalars['Int']>;
  enabled: Scalars['Boolean'];
};

export type AdminCreateMasterProductInput = {
  code: Scalars['String'];
};

export type CreateOrderLimitInput = {
  shippingDate: Scalars['Date'];
  capacity: Scalars['Int'];
};

export type UpdateOrderLimitInput = {
  orderLimitId: Scalars['ID'];
  capacity: Scalars['Int'];
};

export type AdminCreateOrderFulfillmentInput = {
  code: Scalars['String'];
  events: Array<AdminCreateOrderFulfillmentEventInput>;
};

export type AdminCreateOrderFulfillmentEventInput = {
  type: OrderFulfillmentEventType;
  eventDate: DateRange;
  isAllDay: Scalars['Boolean'];
};

export type AdminCreateGoodsScheduleInput = {
  goodsSpecId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  menuSetInputs: Array<MenuSetInput>;
};

export type MenuSetInput = {
  menuId: Scalars['ID'];
  quantity: Scalars['Int'];
  pos: Scalars['Int'];
};

export type AdminUpdateGoodsScheduleInput = {
  goodsScheduleId: Scalars['ID'];
  goodsSpecId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  menuSetInputs: Array<MenuSetInput>;
};

export type AdminImportShippingOldInput = {
  csvFile: Scalars['Upload'];
};

export type ImportShippingCsv = {
  isSuccess: Scalars['Boolean'];
  failedCount: Scalars['Int'];
  failedRows: Array<FailedRow>;
};

export type AdminImportShippingInput = {
  shippingDate: Scalars['Date'];
  csvFile: Scalars['Upload'];
};

export type AdminCreateFutureStockInput = {
  warehouseId: Scalars['ID'];
  masterProductId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  futureQuantity?: Maybe<Scalars['Int']>;
  securedQuantity?: Maybe<Scalars['Int']>;
};

export type AdminStoreStockInput = {
  stockId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type AdminChangeStockInput = {
  warehouseId: Scalars['ID'];
  masterProductId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  stockQuantity?: Maybe<Scalars['Int']>;
  securedQuantity?: Maybe<Scalars['Int']>;
};

export type ContactInput = {
  contactType: Scalars['Int'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  phone: Scalars['String'];
  contents: Scalars['String'];
};

export type Contact = {
  userId: Scalars['ID'];
};

export type OrderFfGoodsInput = {
  paymentMethod: PaymentMethod;
  partnerServiceContractId: Scalars['ID'];
  goodId: Scalars['ID'];
  fulfillmentProcessId: Scalars['ID'];
  orderQuantity: Scalars['Int'];
  storeId: Scalars['ID'];
  storeShippingAddressId: Scalars['ID'];
  deliveryDate: Scalars['Date'];
  deliveryTimeSlot: Scalars['Int'];
  cardId?: Maybe<Scalars['ID']>;
};

export type CancelFfGoodsOrderInput = {
  orderId: Scalars['ID'];
};

export type UpdateDeliveryTimeInput = {
  orderId: Scalars['ID'];
  deliveryDate: Scalars['Date'];
  deliveryTimeSlot: Scalars['Int'];
};

export type CreateAgentSalesOrderInput = {
  consumerPartnerId: Scalars['ID'];
  storeId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  email: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  deliveryFrequency: DeliveryFrequency;
  numberOfDeliveries: Scalars['Int'];
  deliveryDayOfWeek: XDayOfWeek;
  deliveryTimeSlot: Scalars['Int'];
  paymentMethod: PaymentMethod;
  orderItems: Array<CreateAgentSalesOrderItemInput>;
  discountCode?: Maybe<Scalars['String']>;
};

export type CreateAgentSalesOrderItemInput = {
  productId: Scalars['ID'];
  quantity: Scalars['Int'];
};

export type UpdateAgentSalesOrderInput = {
  agentSalesOrderId: Scalars['ID'];
  deliveryAddress?: Maybe<AddressInput>;
  deliveryOptions?: Maybe<ProgramDeliveryOptionsInput>;
};

export type AddressInput = {
  zipCode: Scalars['String'];
  prefId: Scalars['String'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
};

export type CancelAgentSalesShippingItemInput = {
  agentSalesOrderId: Scalars['ID'];
  agentSalesOrderItemId: Scalars['ID'];
  agentSalesShippingItemId: Scalars['ID'];
};

export type CreateStoreOwnerInput = {
  partnerId: Scalars['ID'];
  userId: Scalars['ID'];
  storeIds: Array<Scalars['ID']>;
};

export type CreateStoreShippingAddressInput = {
  storeId: Scalars['ID'];
  name: Scalars['String'];
  destinationName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  companyDepartment?: Maybe<Scalars['String']>;
};

export type UpdateStoreShippingAddressInput = {
  id: Scalars['ID'];
  storeId: Scalars['ID'];
  name: Scalars['String'];
  destinationName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  companyDepartment?: Maybe<Scalars['String']>;
};

export type CreatePartnerBankAccountInput = {
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
  bankName: Scalars['String'];
  branchNumber: Scalars['String'];
  branchName: Scalars['String'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: AccountType;
};

export type UpdatePartnerBankAccountInput = {
  partnerBankAccountId: Scalars['ID'];
  partnerId: Scalars['ID'];
  storeId?: Maybe<Scalars['ID']>;
  bankName: Scalars['String'];
  branchNumber: Scalars['String'];
  branchName: Scalars['String'];
  accountName: Scalars['String'];
  accountNumber: Scalars['String'];
  accountType: AccountType;
};

export type CreatePartnerApplicationInput = {
  applicantFirstName: Scalars['String'];
  applicantLastName: Scalars['String'];
  applicantEmail: Scalars['String'];
  useAffiliate: Scalars['Boolean'];
  servicePlanIds?: Maybe<Array<Scalars['ID']>>;
  companyName: Scalars['String'];
  ownerName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  referrer?: Maybe<Scalars['String']>;
  storeApplications: Array<CreateStoreApplicationInput>;
};

export type CreateStoreApplicationInput = {
  name: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  siteUrl: Scalars['String'];
  industryId: Scalars['ID'];
  industryFreeWord?: Maybe<Scalars['String']>;
};

export type RegisterInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  birthday?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
  memberType?: Maybe<MemberType>;
  partnerId?: Maybe<Scalars['String']>;
};

export type AuthPayload = {
  user?: Maybe<User>;
};

export type LoginInput = {
  email: Scalars['String'];
  password: Scalars['String'];
};

export type ForgotPasswordInput = {
  email: Scalars['String'];
};

export type ResetPasswordInput = {
  email: Scalars['String'];
  password: Scalars['String'];
  token: Scalars['String'];
};

export type UpdatePasswordInput = {
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
};

export type UpdateProfileInput = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  birthday?: Maybe<Scalars['Date']>;
  gender?: Maybe<Scalars['Int']>;
  height?: Maybe<Scalars['Float']>;
  weight?: Maybe<Scalars['Float']>;
};

export type CreateShippingAddressInput = {
  name: Scalars['String'];
  destinationName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  companyDepartment?: Maybe<Scalars['String']>;
};

export type UpdateShippingAddressInput = {
  id: Scalars['String'];
  name: Scalars['String'];
  destinationName: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  companyDepartment?: Maybe<Scalars['String']>;
};

export type CreateAgentSalesDestinationInput = {
  partnerId: Scalars['ID'];
  storeId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  email: Scalars['String'];
};

export type UpdateAgentSalesDestinationInput = {
  agentSalesDestinationId: Scalars['ID'];
  partnerId: Scalars['ID'];
  storeId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  firstNameKana: Scalars['String'];
  lastNameKana: Scalars['String'];
  zipCode: Scalars['String'];
  prefId: Scalars['Int'];
  address1: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  email: Scalars['String'];
};

/** 在庫販売商品  */
export type AgentSalesGoods = SalesProduct & {
  type: ServicePlanType;
  product: FfGoods;
  available: Scalars['Boolean'];
  availableQuantity: Scalars['Int'];
};

/**  受注販売商品  */
export type StoreSalesGoods = SalesProduct & {
  type: ServicePlanType;
  product: FfGoods;
  available: Scalars['Boolean'];
  availableQuantity: Scalars['Int'];
  fulfillmentProcessId: Scalars['ID'];
  shippingDate: Scalars['Date'];
  fixedDate: Scalars['Date'];
  menuSets?: Maybe<Array<MenuSet>>;
};

export type ServiceGoods = ServiceProduct & {
  type: ServiceProductType;
  serviceProductId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  goods?: Maybe<Goods>;
};

export type ServiceGoodsSeries = ServiceProduct & {
  type: ServiceProductType;
  serviceProductId: Scalars['ID'];
  servicePlanId: Scalars['ID'];
  startsAt: Scalars['Date'];
  endsAt?: Maybe<Scalars['Date']>;
  goodsSeries?: Maybe<GoodsSeries>;
};

export type ShippingPaginator = {
  data: Array<Shipping>;
  paginatorInfo: PaginatorInfo;
};

export type PayjpTransfer = {
  payjpTransferId: Scalars['ID'];
  termStart: Scalars['Date'];
  termEnd: Scalars['Date'];
  amount: Scalars['Int'];
  chargeCount: Scalars['Int'];
  chargeFee: Scalars['Int'];
  chargeGross: Scalars['Int'];
  net: Scalars['Int'];
  refundAmount: Scalars['Int'];
  refundCount: Scalars['Int'];
  disputeAmount: Scalars['Int'];
  disputeCount: Scalars['Int'];
  payjpTransactionId: Scalars['String'];
  items: Array<PayjpTransferItem>;
};

export type LogoutPayload = {
  user?: Maybe<User>;
};

export type DateTimeRange = {
  from?: Maybe<Scalars['DateTime']>;
  to?: Maybe<Scalars['DateTime']>;
};


export type MenuQuantityInput = {
  menuId: Scalars['ID'];
  quantity: Scalars['Int'];
  pos: Scalars['Int'];
};

export type PartnerInput = {
  partnerId: Scalars['ID'];
};

/** Aggregate functions when ordering by a relation without specifying a column. */
export enum OrderByRelationAggregateFunction {
  /** Amount of items. */
  Count = 'COUNT'
}

/** Aggregate functions when ordering by a relation that may specify a column. */
export enum OrderByRelationWithColumnAggregateFunction {
  /** Average. */
  Avg = 'AVG',
  /** Minimum. */
  Min = 'MIN',
  /** Maximum. */
  Max = 'MAX',
  /** Sum. */
  Sum = 'SUM',
  /** Amount of items. */
  Count = 'COUNT'
}

/** Information about pagination using a simple paginator. */
export type SimplePaginatorInfo = {
  /** Number of items in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the first item in the current page. */
  firstItem?: Maybe<Scalars['Int']>;
  /** Index of the last item in the current page. */
  lastItem?: Maybe<Scalars['Int']>;
  /** Number of items per page. */
  perPage: Scalars['Int'];
  /** Are there more pages after this one? */
  hasMorePages: Scalars['Boolean'];
};

/** Information about pagination using a Relay style cursor connection. */
export type PageInfo = {
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** The cursor to continue paginating backwards. */
  startCursor?: Maybe<Scalars['String']>;
  /** The cursor to continue paginating forwards. */
  endCursor?: Maybe<Scalars['String']>;
  /** Total number of nodes in the paginated connection. */
  total: Scalars['Int'];
  /** Number of nodes in the current page. */
  count: Scalars['Int'];
  /** Index of the current page. */
  currentPage: Scalars['Int'];
  /** Index of the last available page. */
  lastPage: Scalars['Int'];
};

/** Specify if you want to include or exclude trashed results from a query. */
export enum Trashed {
  /** Only return trashed results. */
  Only = 'ONLY',
  /** Return both trashed and non-trashed results. */
  With = 'WITH',
  /** Only return non-trashed results. */
  Without = 'WITHOUT'
}
